/* tslint:disable */
/* eslint-disable */
/**
 * @mogul/api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from './common';
// @ts-ignore
import { BASE_PATH, BaseAPI } from './base';
/**
 *
 * @export
 * @enum {string}
 */
export var AssetInclude;
(function (AssetInclude) {
    AssetInclude["Listings"] = "listings";
    AssetInclude["Media"] = "media";
    AssetInclude["CreatedBy"] = "createdBy";
})(AssetInclude || (AssetInclude = {}));
/**
 *
 * @export
 * @enum {string}
 */
export var AssetSort;
(function (AssetSort) {
    AssetSort["ContractAddressAsc"] = "contractAddress-asc";
    AssetSort["ContractAddressDesc"] = "contractAddress-desc";
    AssetSort["CreatedAtAsc"] = "createdAt-asc";
    AssetSort["CreatedAtDesc"] = "createdAt-desc";
    AssetSort["IdAsc"] = "id-asc";
    AssetSort["IdDesc"] = "id-desc";
    AssetSort["IssueCountAsc"] = "issueCount-asc";
    AssetSort["IssueCountDesc"] = "issueCount-desc";
    AssetSort["IssueNumberAsc"] = "issueNumber-asc";
    AssetSort["IssueNumberDesc"] = "issueNumber-desc";
    AssetSort["StatusAsc"] = "status-asc";
    AssetSort["StatusDesc"] = "status-desc";
    AssetSort["TotalSupplyAsc"] = "totalSupply-asc";
    AssetSort["TotalSupplyDesc"] = "totalSupply-desc";
    AssetSort["UpdatedAtAsc"] = "updatedAt-asc";
    AssetSort["UpdatedAtDesc"] = "updatedAt-desc";
})(AssetSort || (AssetSort = {}));
/**
 *
 * @export
 * @enum {string}
 */
export var BidInclude;
(function (BidInclude) {
    BidInclude["Auction"] = "auction";
})(BidInclude || (BidInclude = {}));
/**
 *
 * @export
 * @enum {string}
 */
export var BidSort;
(function (BidSort) {
    BidSort["IdAsc"] = "id-asc";
    BidSort["IdDesc"] = "id-desc";
    BidSort["AmountAsc"] = "amount-asc";
    BidSort["AmountDesc"] = "amount-desc";
    BidSort["BidderAddressAsc"] = "bidderAddress-asc";
    BidSort["BidderAddressDesc"] = "bidderAddress-desc";
})(BidSort || (BidSort = {}));
/**
 *
 * @export
 * @enum {string}
 */
export var CollectionSort;
(function (CollectionSort) {
    CollectionSort["CreatedAtAsc"] = "createdAt-asc";
    CollectionSort["CreatedAtDesc"] = "createdAt-desc";
    CollectionSort["UpdatedAtAsc"] = "updatedAt-asc";
    CollectionSort["UpdatedAtDesc"] = "updatedAt-desc";
    CollectionSort["NameAsc"] = "name-asc";
    CollectionSort["NameDesc"] = "name-desc";
})(CollectionSort || (CollectionSort = {}));
/**
 *
 * @export
 * @enum {string}
 */
export var EntityTypeName;
(function (EntityTypeName) {
    EntityTypeName["User"] = "User";
    EntityTypeName["ApiKey"] = "ApiKey";
    EntityTypeName["File"] = "File";
    EntityTypeName["Post"] = "Post";
    EntityTypeName["Project"] = "Project";
    EntityTypeName["ProjectFileAttachment"] = "ProjectFileAttachment";
    EntityTypeName["ProjectGalleryImage"] = "ProjectGalleryImage";
    EntityTypeName["Collection"] = "Collection";
    EntityTypeName["WalletUser"] = "WalletUser";
    EntityTypeName["Wallet"] = "Wallet";
    EntityTypeName["Nft"] = "Nft";
    EntityTypeName["Transactions"] = "Transactions";
    EntityTypeName["Artist"] = "Artist";
    EntityTypeName["Roadmap"] = "Roadmap";
    EntityTypeName["Faq"] = "Faq";
    EntityTypeName["LaunchPad"] = "LaunchPad";
    EntityTypeName["Whitelist"] = "Whitelist";
    EntityTypeName["ProjectSubmission"] = "ProjectSubmission";
    EntityTypeName["EmailToNotify"] = "EmailToNotify";
    EntityTypeName["Order"] = "Order";
    EntityTypeName["OrderItemOwner"] = "OrderItemOwner";
})(EntityTypeName || (EntityTypeName = {}));
/**
 *
 * @export
 * @enum {string}
 */
export var ErrorCode;
(function (ErrorCode) {
    ErrorCode["ApiKeyNotFound"] = "apiKey.notFound";
    ErrorCode["AppInternalError"] = "app.internalError";
    ErrorCode["AppNotFound"] = "app.notFound";
    ErrorCode["AuthEmailVerificationRequired"] = "auth.emailVerificationRequired";
    ErrorCode["AuthForbidden"] = "auth.forbidden";
    ErrorCode["AuthMfaRequired"] = "auth.mfaRequired";
    ErrorCode["AuthExpired"] = "auth.expired";
    ErrorCode["AuthUnauthorized"] = "auth.unauthorized";
    ErrorCode["CaptchaError"] = "captcha.error";
    ErrorCode["UserIdentityConflict"] = "user.identityConflict";
    ErrorCode["UserMfaActive"] = "user.mfaActive";
    ErrorCode["UserNotFound"] = "user.notFound";
    ErrorCode["WalletNotFound"] = "wallet.notFound";
    ErrorCode["WalletLaunchpadNotFound"] = "walletLaunchpad.notFound";
    ErrorCode["WalletUserNotFound"] = "walletUser.notFound";
    ErrorCode["FileNotFound"] = "file.notFound";
    ErrorCode["FileInvalidStorageKey"] = "file.invalidStorageKey";
    ErrorCode["FileInvalidId"] = "file.invalidId";
    ErrorCode["FileInvalidFormat"] = "file.invalidFormat";
    ErrorCode["MediaNotFound"] = "media.notFound";
    ErrorCode["MediaInvalidType"] = "media.invalidType";
    ErrorCode["FileIsTooLarge"] = "FileIsTooLarge";
    ErrorCode["EventNotFound"] = "event.notFound";
    ErrorCode["ProjectNotFound"] = "project.notFound";
    ErrorCode["ProjectTooManyTeams"] = "project.tooManyTeams";
    ErrorCode["CollectionNotFound"] = "collection.notFound";
    ErrorCode["UnlockableContentForbidden"] = "unlockableContent.forbidden";
    ErrorCode["ImageNotFound"] = "image.notFound";
    ErrorCode["NftNotFound"] = "nft.notFound";
    ErrorCode["NftExists"] = "nft.exists";
    ErrorCode["MogieNotFound"] = "mogie.notFound";
    ErrorCode["SearchDocNotFound"] = "searchDoc.notFound";
    ErrorCode["SearchDocInvalidEntity"] = "searchDoc.invalidEntity";
    ErrorCode["SearchDocInvalidType"] = "searchDoc.invalidType";
    ErrorCode["AssetNotFound"] = "asset.notFound";
    ErrorCode["ListingNotFound"] = "listing.notFound";
    ErrorCode["BidNotFound"] = "bid.notFound";
    ErrorCode["TransactionNotFound"] = "transaction.notFound";
    ErrorCode["TransactionEmailNotFound"] = "transaction.emailNotFound";
    ErrorCode["LaunchpadNotFound"] = "launchpad.notFound";
    ErrorCode["ArtistNotFound"] = "artist.notFound";
    ErrorCode["RoadmapNotFound"] = "roadmap.notFound";
    ErrorCode["FaqNotFound"] = "faq.notFound";
    ErrorCode["WhitelistNotFound"] = "whitelist.notFound";
    ErrorCode["WhitelistExists"] = "whitelist.exists";
    ErrorCode["OrderNotFulfilled"] = "order.notFulfilled";
    ErrorCode["OrderAlreadyFulfilled"] = "order.alreadyFulfilled";
    ErrorCode["OrderVerificationFailed"] = "order.verificationFailed";
    ErrorCode["OrderInvalidSignature"] = "order.invalidSignature";
})(ErrorCode || (ErrorCode = {}));
/**
 *
 * @export
 * @enum {string}
 */
export var ItemType;
(function (ItemType) {
    ItemType[ItemType["NUMBER_0"] = 0] = "NUMBER_0";
    ItemType[ItemType["NUMBER_1"] = 1] = "NUMBER_1";
    ItemType[ItemType["NUMBER_2"] = 2] = "NUMBER_2";
    ItemType[ItemType["NUMBER_3"] = 3] = "NUMBER_3";
    ItemType[ItemType["NUMBER_4"] = 4] = "NUMBER_4";
    ItemType[ItemType["NUMBER_5"] = 5] = "NUMBER_5";
})(ItemType || (ItemType = {}));
/**
 *
 * @export
 * @enum {string}
 */
export var LaunchPadSort;
(function (LaunchPadSort) {
    LaunchPadSort["CreatedAtAsc"] = "createdAt-asc";
    LaunchPadSort["CreatedAtDesc"] = "createdAt-desc";
    LaunchPadSort["UpdatedAtAsc"] = "updatedAt-asc";
    LaunchPadSort["UpdatedAtDesc"] = "updatedAt-desc";
    LaunchPadSort["NameAsc"] = "name-asc";
    LaunchPadSort["NameDesc"] = "name-desc";
    LaunchPadSort["SaleDateAsc"] = "saleDate-asc";
    LaunchPadSort["SaleDateDesc"] = "saleDate-desc";
    LaunchPadSort["EndDateAsc"] = "endDate-asc";
    LaunchPadSort["EndDateDesc"] = "endDate-desc";
    LaunchPadSort["TotalSupplyAsc"] = "totalSupply-asc";
    LaunchPadSort["TotalSupplyDesc"] = "totalSupply-desc";
})(LaunchPadSort || (LaunchPadSort = {}));
/**
 *
 * @export
 * @enum {string}
 */
export var LaunchPadType;
(function (LaunchPadType) {
    LaunchPadType["FeaturedPage"] = "FEATURED PAGE";
    LaunchPadType["NftDrop"] = "NFT DROP";
})(LaunchPadType || (LaunchPadType = {}));
/**
 *
 * @export
 * @enum {string}
 */
export var ListingInclude;
(function (ListingInclude) {
    ListingInclude["Asset"] = "asset";
    ListingInclude["Bids"] = "bids";
})(ListingInclude || (ListingInclude = {}));
/**
 *
 * @export
 * @enum {string}
 */
export var ListingSort;
(function (ListingSort) {
    ListingSort["ContractAddressAsc"] = "contractAddress-asc";
    ListingSort["ContractAddressDesc"] = "contractAddress-desc";
    ListingSort["CreatedAtAsc"] = "createdAt-asc";
    ListingSort["CreatedAtDesc"] = "createdAt-desc";
    ListingSort["IdAsc"] = "id-asc";
    ListingSort["IdDesc"] = "id-desc";
    ListingSort["IssueCountAsc"] = "issueCount-asc";
    ListingSort["IssueCountDesc"] = "issueCount-desc";
    ListingSort["IssueNumberAsc"] = "issueNumber-asc";
    ListingSort["IssueNumberDesc"] = "issueNumber-desc";
    ListingSort["StatusAsc"] = "status-asc";
    ListingSort["StatusDesc"] = "status-desc";
    ListingSort["TotalSupplyAsc"] = "totalSupply-asc";
    ListingSort["TotalSupplyDesc"] = "totalSupply-desc";
    ListingSort["UpdatedAtAsc"] = "updatedAt-asc";
    ListingSort["UpdatedAtDesc"] = "updatedAt-desc";
})(ListingSort || (ListingSort = {}));
/**
 *
 * @export
 * @enum {string}
 */
export var ListingStatus;
(function (ListingStatus) {
    ListingStatus["Created"] = "CREATED";
    ListingStatus["Ended"] = "ENDED";
    ListingStatus["Cancelled"] = "CANCELLED";
})(ListingStatus || (ListingStatus = {}));
/**
 *
 * @export
 * @enum {string}
 */
export var ListingTypeAuction;
(function (ListingTypeAuction) {
    ListingTypeAuction["Auction"] = "AUCTION";
})(ListingTypeAuction || (ListingTypeAuction = {}));
/**
 *
 * @export
 * @enum {string}
 */
export var ListingTypeSale;
(function (ListingTypeSale) {
    ListingTypeSale["Sale"] = "SALE";
})(ListingTypeSale || (ListingTypeSale = {}));
/**
 *
 * @export
 * @enum {string}
 */
export var MogieRarity;
(function (MogieRarity) {
    MogieRarity["Common"] = "COMMON";
    MogieRarity["Tier1"] = "TIER1";
    MogieRarity["Tier2"] = "TIER2";
    MogieRarity["Tier3"] = "TIER3";
    MogieRarity["Tier4"] = "TIER4";
})(MogieRarity || (MogieRarity = {}));
/**
 *
 * @export
 * @enum {string}
 */
export var MogieSort;
(function (MogieSort) {
    MogieSort["CreatedAtAsc"] = "createdAt-asc";
    MogieSort["CreatedAtDesc"] = "createdAt-desc";
    MogieSort["IdAsc"] = "id-asc";
    MogieSort["IdDesc"] = "id-desc";
    MogieSort["UpdatedAtAsc"] = "updatedAt-asc";
    MogieSort["UpdatedAtDesc"] = "updatedAt-desc";
    MogieSort["TitleAsc"] = "title-asc";
    MogieSort["TitleDesc"] = "title-desc";
    MogieSort["SerialAsc"] = "serial-asc";
    MogieSort["SerialDesc"] = "serial-desc";
})(MogieSort || (MogieSort = {}));
/**
 *
 * @export
 * @enum {string}
 */
export var Network;
(function (Network) {
    Network["Mainnet"] = "MAINNET";
    Network["Binance"] = "BINANCE";
    Network["Bsctest"] = "BSCTEST";
    Network["Rinkeby"] = "RINKEBY";
    Network["Goerli"] = "GOERLI";
})(Network || (Network = {}));
/**
 *
 * @export
 * @enum {string}
 */
export var NftInclude;
(function (NftInclude) {
    NftInclude["CreatedBy"] = "createdBy";
    NftInclude["Project"] = "project";
})(NftInclude || (NftInclude = {}));
/**
 *
 * @export
 * @enum {string}
 */
export var NftSort;
(function (NftSort) {
    NftSort["ContractAddressAsc"] = "contractAddress-asc";
    NftSort["ContractAddressDesc"] = "contractAddress-desc";
    NftSort["CreatedAtAsc"] = "createdAt-asc";
    NftSort["CreatedAtDesc"] = "createdAt-desc";
    NftSort["IdAsc"] = "id-asc";
    NftSort["IdDesc"] = "id-desc";
    NftSort["IssueCountAsc"] = "issueCount-asc";
    NftSort["IssueCountDesc"] = "issueCount-desc";
    NftSort["IssueNumberAsc"] = "issueNumber-asc";
    NftSort["IssueNumberDesc"] = "issueNumber-desc";
    NftSort["StatusAsc"] = "status-asc";
    NftSort["StatusDesc"] = "status-desc";
    NftSort["TotalSupplyAsc"] = "totalSupply-asc";
    NftSort["TotalSupplyDesc"] = "totalSupply-desc";
    NftSort["UpdatedAtAsc"] = "updatedAt-asc";
    NftSort["UpdatedAtDesc"] = "updatedAt-desc";
    NftSort["TitleAsc"] = "title-asc";
    NftSort["TitleDesc"] = "title-desc";
})(NftSort || (NftSort = {}));
/**
 *
 * @export
 * @enum {string}
 */
export var NftStatus;
(function (NftStatus) {
    NftStatus["Draft"] = "DRAFT";
    NftStatus["Minted"] = "MINTED";
    NftStatus["Deleted"] = "DELETED";
})(NftStatus || (NftStatus = {}));
/**
 *
 * @export
 * @enum {string}
 */
export var PlatformRole;
(function (PlatformRole) {
    PlatformRole["None"] = "NONE";
    PlatformRole["Read"] = "READ";
    PlatformRole["Manage"] = "MANAGE";
    PlatformRole["Admin"] = "ADMIN";
})(PlatformRole || (PlatformRole = {}));
/**
 *
 * @export
 * @enum {string}
 */
export var PostInclude;
(function (PostInclude) {
    PostInclude["CreatedBy"] = "createdBy";
})(PostInclude || (PostInclude = {}));
/**
 *
 * @export
 * @enum {string}
 */
export var PostSort;
(function (PostSort) {
    PostSort["EventDateAsc"] = "eventDate-asc";
    PostSort["EventDateDesc"] = "eventDate-desc";
    PostSort["CreatedAtAsc"] = "createdAt-asc";
    PostSort["CreatedAtDesc"] = "createdAt-desc";
    PostSort["UpdatedAtAsc"] = "updatedAt-asc";
    PostSort["UpdatedAtDesc"] = "updatedAt-desc";
})(PostSort || (PostSort = {}));
/**
 *
 * @export
 * @enum {string}
 */
export var PostStatus;
(function (PostStatus) {
    PostStatus["Draft"] = "DRAFT";
    PostStatus["Published"] = "PUBLISHED";
    PostStatus["Deleted"] = "DELETED";
})(PostStatus || (PostStatus = {}));
/**
 *
 * @export
 * @enum {string}
 */
export var PostType;
(function (PostType) {
    PostType["Event"] = "event";
    PostType["Update"] = "update";
})(PostType || (PostType = {}));
/**
 *
 * @export
 * @enum {string}
 */
export var ProjectFilter;
(function (ProjectFilter) {
    ProjectFilter["Financed"] = "financed";
})(ProjectFilter || (ProjectFilter = {}));
/**
 *
 * @export
 * @enum {string}
 */
export var ProjectInclude;
(function (ProjectInclude) {
    ProjectInclude["CreatedBy"] = "createdBy";
    ProjectInclude["GalleryImages"] = "galleryImages";
    ProjectInclude["AttachedFiles"] = "attachedFiles";
    ProjectInclude["Nfts"] = "nfts";
})(ProjectInclude || (ProjectInclude = {}));
/**
 *
 * @export
 * @enum {string}
 */
export var ProjectListInclude;
(function (ProjectListInclude) {
    ProjectListInclude["CreatedBy"] = "createdBy";
    ProjectListInclude["Nfts"] = "nfts";
})(ProjectListInclude || (ProjectListInclude = {}));
/**
 *
 * @export
 * @enum {string}
 */
export var ProjectProductionStatus;
(function (ProjectProductionStatus) {
    ProjectProductionStatus["PreProduction"] = "PRE_PRODUCTION";
    ProjectProductionStatus["Production"] = "PRODUCTION";
    ProjectProductionStatus["PostProduction"] = "POST_PRODUCTION";
    ProjectProductionStatus["Distribution"] = "DISTRIBUTION";
})(ProjectProductionStatus || (ProjectProductionStatus = {}));
/**
 *
 * @export
 * @enum {string}
 */
export var ProjectSort;
(function (ProjectSort) {
    ProjectSort["CreatedAtAsc"] = "createdAt-asc";
    ProjectSort["CreatedAtDesc"] = "createdAt-desc";
    ProjectSort["StatusAsc"] = "status-asc";
    ProjectSort["StatusDesc"] = "status-desc";
    ProjectSort["UpdatedAtAsc"] = "updatedAt-asc";
    ProjectSort["UpdatedAtDesc"] = "updatedAt-desc";
    ProjectSort["TitleAsc"] = "title-asc";
    ProjectSort["TitleDesc"] = "title-desc";
})(ProjectSort || (ProjectSort = {}));
/**
 *
 * @export
 * @enum {string}
 */
export var ProjectStatus;
(function (ProjectStatus) {
    ProjectStatus["Draft"] = "DRAFT";
    ProjectStatus["Published"] = "PUBLISHED";
})(ProjectStatus || (ProjectStatus = {}));
/**
 *
 * @export
 * @enum {string}
 */
export var SaleStrategy;
(function (SaleStrategy) {
    SaleStrategy["Simplified"] = "Simplified";
    SaleStrategy["Tiered"] = "Tiered";
})(SaleStrategy || (SaleStrategy = {}));
/**
 *
 * @export
 * @enum {string}
 */
export var TokenType;
(function (TokenType) {
    TokenType["Erc721"] = "ERC721";
    TokenType["Erc1155"] = "ERC1155";
    TokenType["Erc1155Mintable"] = "ERC1155 Mintable";
})(TokenType || (TokenType = {}));
/**
 *
 * @export
 * @enum {string}
 */
export var TransactionType;
(function (TransactionType) {
    TransactionType["CreateListing"] = "CREATE_LISTING";
    TransactionType["CreateAuction"] = "CREATE_AUCTION";
    TransactionType["Buy"] = "BUY";
    TransactionType["Bid"] = "BID";
})(TransactionType || (TransactionType = {}));
/**
 *
 * @export
 * @enum {string}
 */
export var UnlockableContentType;
(function (UnlockableContentType) {
    UnlockableContentType["Markdown"] = "MARKDOWN";
    UnlockableContentType["Image"] = "IMAGE";
    UnlockableContentType["Video"] = "VIDEO";
    UnlockableContentType["Audio"] = "AUDIO";
})(UnlockableContentType || (UnlockableContentType = {}));
/**
 *
 * @export
 * @enum {string}
 */
export var UserInclude;
(function (UserInclude) {
    UserInclude["CreatedBy"] = "createdBy";
    UserInclude["Preferences"] = "preferences";
    UserInclude["Meta"] = "meta";
})(UserInclude || (UserInclude = {}));
/**
 *
 * @export
 * @enum {string}
 */
export var UserSort;
(function (UserSort) {
    UserSort["CreatedAtAsc"] = "createdAt-asc";
    UserSort["CreatedAtDesc"] = "createdAt-desc";
    UserSort["EmailAsc"] = "email-asc";
    UserSort["EmailDesc"] = "email-desc";
    UserSort["NameAsc"] = "name-asc";
    UserSort["NameDesc"] = "name-desc";
    UserSort["RoleAsc"] = "role-asc";
    UserSort["RoleDesc"] = "role-desc";
    UserSort["StatusAsc"] = "status-asc";
    UserSort["StatusDesc"] = "status-desc";
    UserSort["UpdatedAtAsc"] = "updatedAt-asc";
    UserSort["UpdatedAtDesc"] = "updatedAt-desc";
    UserSort["UsernameAsc"] = "username-asc";
    UserSort["UsernameDesc"] = "username-desc";
})(UserSort || (UserSort = {}));
/**
 *
 * @export
 * @enum {string}
 */
export var UserStatus;
(function (UserStatus) {
    UserStatus["Pending"] = "PENDING";
    UserStatus["Active"] = "ACTIVE";
    UserStatus["Recovery"] = "RECOVERY";
    UserStatus["Deactivated"] = "DEACTIVATED";
})(UserStatus || (UserStatus = {}));
/**
 *
 * @export
 * @enum {string}
 */
export var VariantFormat;
(function (VariantFormat) {
    VariantFormat["Gif"] = "gif";
    VariantFormat["Jpeg"] = "jpeg";
    VariantFormat["Webp"] = "webp";
    VariantFormat["Png"] = "png";
    VariantFormat["Mp4"] = "mp4";
    VariantFormat["Webm"] = "webm";
})(VariantFormat || (VariantFormat = {}));
/**
 *
 * @export
 * @enum {string}
 */
export var WhitelistSort;
(function (WhitelistSort) {
    WhitelistSort["CreatedAtAsc"] = "createdAt-asc";
    WhitelistSort["CreatedAtDesc"] = "createdAt-desc";
    WhitelistSort["UpdatedAtAsc"] = "updatedAt-asc";
    WhitelistSort["UpdatedAtDesc"] = "updatedAt-desc";
})(WhitelistSort || (WhitelistSort = {}));
/**
 * AppConfigApi - axios parameter creator
 * @export
 */
export const AppConfigApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {string} key
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAppConfig: async (key, options = {}) => {
            // verify required parameter 'key' is not null or undefined
            assertParamExists('getAppConfig', 'key', key);
            const localVarPath = `/app-config/{key}`
                .replace(`{${"key"}}`, encodeURIComponent(String(key)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication AccessToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listAppConfig: async (options = {}) => {
            const localVarPath = `/app-config`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication AccessToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {AppConfigCreateData} appConfigCreateData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setAppConfig: async (appConfigCreateData, options = {}) => {
            // verify required parameter 'appConfigCreateData' is not null or undefined
            assertParamExists('setAppConfig', 'appConfigCreateData', appConfigCreateData);
            const localVarPath = `/app-config`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication AccessToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(appConfigCreateData, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * AppConfigApi - functional programming interface
 * @export
 */
export const AppConfigApiFp = function (configuration) {
    const localVarAxiosParamCreator = AppConfigApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @param {string} key
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAppConfig(key, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAppConfig(key, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listAppConfig(options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listAppConfig(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {AppConfigCreateData} appConfigCreateData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async setAppConfig(appConfigCreateData, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.setAppConfig(appConfigCreateData, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    };
};
/**
 * AppConfigApi - factory interface
 * @export
 */
export const AppConfigApiFactory = function (configuration, basePath, axios) {
    const localVarFp = AppConfigApiFp(configuration);
    return {
        /**
         *
         * @param {string} key
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAppConfig(key, options) {
            return localVarFp.getAppConfig(key, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listAppConfig(options) {
            return localVarFp.listAppConfig(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {AppConfigCreateData} appConfigCreateData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setAppConfig(appConfigCreateData, options) {
            return localVarFp.setAppConfig(appConfigCreateData, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * AppConfigApi - object-oriented interface
 * @export
 * @class AppConfigApi
 * @extends {BaseAPI}
 */
export class AppConfigApi extends BaseAPI {
    /**
     *
     * @param {AppConfigApiGetAppConfigRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AppConfigApi
     */
    getAppConfig(requestParameters, options) {
        return AppConfigApiFp(this.configuration).getAppConfig(requestParameters.key, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AppConfigApi
     */
    listAppConfig(options) {
        return AppConfigApiFp(this.configuration).listAppConfig(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {AppConfigApiSetAppConfigRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AppConfigApi
     */
    setAppConfig(requestParameters, options) {
        return AppConfigApiFp(this.configuration).setAppConfig(requestParameters.appConfigCreateData, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * ArtistApi - axios parameter creator
 * @export
 */
export const ArtistApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {FileCreateData} fileCreateData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        artistsImageUpload: async (fileCreateData, options = {}) => {
            // verify required parameter 'fileCreateData' is not null or undefined
            assertParamExists('artistsImageUpload', 'fileCreateData', fileCreateData);
            const localVarPath = `/artist/image-upload`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication AccessToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(fileCreateData, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {ArtistCreateData} artistCreateData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createArtist: async (artistCreateData, options = {}) => {
            // verify required parameter 'artistCreateData' is not null or undefined
            assertParamExists('createArtist', 'artistCreateData', artistCreateData);
            const localVarPath = `/artist`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication AccessToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(artistCreateData, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteArtist: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteArtist', 'id', id);
            const localVarPath = `/artist/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication AccessToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getArtist: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getArtist', 'id', id);
            const localVarPath = `/artist/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} id
         * @param {ArtistUpdateData} artistUpdateData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateArtist: async (id, artistUpdateData, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateArtist', 'id', id);
            // verify required parameter 'artistUpdateData' is not null or undefined
            assertParamExists('updateArtist', 'artistUpdateData', artistUpdateData);
            const localVarPath = `/artist/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication AccessToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(artistUpdateData, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * ArtistApi - functional programming interface
 * @export
 */
export const ArtistApiFp = function (configuration) {
    const localVarAxiosParamCreator = ArtistApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @param {FileCreateData} fileCreateData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async artistsImageUpload(fileCreateData, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.artistsImageUpload(fileCreateData, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {ArtistCreateData} artistCreateData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createArtist(artistCreateData, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createArtist(artistCreateData, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteArtist(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteArtist(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getArtist(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getArtist(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {string} id
         * @param {ArtistUpdateData} artistUpdateData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateArtist(id, artistUpdateData, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateArtist(id, artistUpdateData, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    };
};
/**
 * ArtistApi - factory interface
 * @export
 */
export const ArtistApiFactory = function (configuration, basePath, axios) {
    const localVarFp = ArtistApiFp(configuration);
    return {
        /**
         *
         * @param {FileCreateData} fileCreateData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        artistsImageUpload(fileCreateData, options) {
            return localVarFp.artistsImageUpload(fileCreateData, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {ArtistCreateData} artistCreateData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createArtist(artistCreateData, options) {
            return localVarFp.createArtist(artistCreateData, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteArtist(id, options) {
            return localVarFp.deleteArtist(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getArtist(id, options) {
            return localVarFp.getArtist(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} id
         * @param {ArtistUpdateData} artistUpdateData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateArtist(id, artistUpdateData, options) {
            return localVarFp.updateArtist(id, artistUpdateData, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * ArtistApi - object-oriented interface
 * @export
 * @class ArtistApi
 * @extends {BaseAPI}
 */
export class ArtistApi extends BaseAPI {
    /**
     *
     * @param {ArtistApiArtistsImageUploadRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ArtistApi
     */
    artistsImageUpload(requestParameters, options) {
        return ArtistApiFp(this.configuration).artistsImageUpload(requestParameters.fileCreateData, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {ArtistApiCreateArtistRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ArtistApi
     */
    createArtist(requestParameters, options) {
        return ArtistApiFp(this.configuration).createArtist(requestParameters.artistCreateData, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {ArtistApiDeleteArtistRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ArtistApi
     */
    deleteArtist(requestParameters, options) {
        return ArtistApiFp(this.configuration).deleteArtist(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {ArtistApiGetArtistRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ArtistApi
     */
    getArtist(requestParameters, options) {
        return ArtistApiFp(this.configuration).getArtist(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {ArtistApiUpdateArtistRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ArtistApi
     */
    updateArtist(requestParameters, options) {
        return ArtistApiFp(this.configuration).updateArtist(requestParameters.id, requestParameters.artistUpdateData, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * AssetApi - axios parameter creator
 * @export
 */
export const AssetApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {AssetCreateData} assetCreateData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAsset: async (assetCreateData, options = {}) => {
            // verify required parameter 'assetCreateData' is not null or undefined
            assertParamExists('createAsset', 'assetCreateData', assetCreateData);
            const localVarPath = `/asset`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication AccessToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(assetCreateData, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} id
         * @param {Array<AssetInclude>} [include]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAsset: async (id, include, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getAsset', 'id', id);
            const localVarPath = `/asset/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication AccessToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (include) {
                localVarQueryParameter['include'] = include;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} [limit]
         * @param {number} [offset]
         * @param {AssetSort} [sort]
         * @param {Array<AssetInclude>} [include]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listAssets: async (limit, offset, sort, include, options = {}) => {
            const localVarPath = `/asset`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication AccessToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }
            if (sort !== undefined) {
                localVarQueryParameter['sort'] = sort;
            }
            if (include) {
                localVarQueryParameter['include'] = include;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} id
         * @param {AssetUpdateData} assetUpdateData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateAsset: async (id, assetUpdateData, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateAsset', 'id', id);
            // verify required parameter 'assetUpdateData' is not null or undefined
            assertParamExists('updateAsset', 'assetUpdateData', assetUpdateData);
            const localVarPath = `/asset/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication AccessToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(assetUpdateData, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * AssetApi - functional programming interface
 * @export
 */
export const AssetApiFp = function (configuration) {
    const localVarAxiosParamCreator = AssetApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @param {AssetCreateData} assetCreateData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createAsset(assetCreateData, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createAsset(assetCreateData, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {string} id
         * @param {Array<AssetInclude>} [include]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAsset(id, include, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAsset(id, include, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {number} [limit]
         * @param {number} [offset]
         * @param {AssetSort} [sort]
         * @param {Array<AssetInclude>} [include]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listAssets(limit, offset, sort, include, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listAssets(limit, offset, sort, include, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {string} id
         * @param {AssetUpdateData} assetUpdateData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateAsset(id, assetUpdateData, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateAsset(id, assetUpdateData, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    };
};
/**
 * AssetApi - factory interface
 * @export
 */
export const AssetApiFactory = function (configuration, basePath, axios) {
    const localVarFp = AssetApiFp(configuration);
    return {
        /**
         *
         * @param {AssetCreateData} assetCreateData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAsset(assetCreateData, options) {
            return localVarFp.createAsset(assetCreateData, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} id
         * @param {Array<AssetInclude>} [include]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAsset(id, include, options) {
            return localVarFp.getAsset(id, include, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} [limit]
         * @param {number} [offset]
         * @param {AssetSort} [sort]
         * @param {Array<AssetInclude>} [include]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listAssets(limit, offset, sort, include, options) {
            return localVarFp.listAssets(limit, offset, sort, include, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} id
         * @param {AssetUpdateData} assetUpdateData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateAsset(id, assetUpdateData, options) {
            return localVarFp.updateAsset(id, assetUpdateData, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * AssetApi - object-oriented interface
 * @export
 * @class AssetApi
 * @extends {BaseAPI}
 */
export class AssetApi extends BaseAPI {
    /**
     *
     * @param {AssetApiCreateAssetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AssetApi
     */
    createAsset(requestParameters, options) {
        return AssetApiFp(this.configuration).createAsset(requestParameters.assetCreateData, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {AssetApiGetAssetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AssetApi
     */
    getAsset(requestParameters, options) {
        return AssetApiFp(this.configuration).getAsset(requestParameters.id, requestParameters.include, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {AssetApiListAssetsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AssetApi
     */
    listAssets(requestParameters = {}, options) {
        return AssetApiFp(this.configuration).listAssets(requestParameters.limit, requestParameters.offset, requestParameters.sort, requestParameters.include, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {AssetApiUpdateAssetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AssetApi
     */
    updateAsset(requestParameters, options) {
        return AssetApiFp(this.configuration).updateAsset(requestParameters.id, requestParameters.assetUpdateData, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * AuthApi - axios parameter creator
 * @export
 */
export const AuthApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {PasswordChangeData} passwordChangeData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPasswordChange: async (passwordChangeData, options = {}) => {
            // verify required parameter 'passwordChangeData' is not null or undefined
            assertParamExists('createPasswordChange', 'passwordChangeData', passwordChangeData);
            const localVarPath = `/password-change`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(passwordChangeData, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createToken: async (options = {}) => {
            const localVarPath = `/token`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication RefreshToken required
            await setApiKeyToObject(localVarQueryParameter, "refresh_token", configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {EmailVerificationData} emailVerificationData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createVerification: async (emailVerificationData, options = {}) => {
            // verify required parameter 'emailVerificationData' is not null or undefined
            assertParamExists('createVerification', 'emailVerificationData', emailVerificationData);
            const localVarPath = `/verification`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(emailVerificationData, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        login: async (options = {}) => {
            const localVarPath = `/login`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication AccessToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            // authentication Basic required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            // authentication MfaToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            // authentication OtpCode required
            await setApiKeyToObject(localVarQueryParameter, "otp_code", configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        logout: async (options = {}) => {
            const localVarPath = `/logout`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication AccessToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            // authentication RefreshToken required
            await setApiKeyToObject(localVarQueryParameter, "refresh_token", configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {SetPasswordData} setPasswordData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setPassword: async (setPasswordData, options = {}) => {
            // verify required parameter 'setPasswordData' is not null or undefined
            assertParamExists('setPassword', 'setPasswordData', setPasswordData);
            const localVarPath = `/password`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication PasswordChangeToken required
            await setApiKeyToObject(localVarQueryParameter, "token", configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(setPasswordData, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {SignupData} signupData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        signup: async (signupData, options = {}) => {
            // verify required parameter 'signupData' is not null or undefined
            assertParamExists('signup', 'signupData', signupData);
            const localVarPath = `/signup`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(signupData, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {PartialSignupData} partialSignupData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateSignup: async (partialSignupData, options = {}) => {
            // verify required parameter 'partialSignupData' is not null or undefined
            assertParamExists('validateSignup', 'partialSignupData', partialSignupData);
            const localVarPath = `/signup/validate`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(partialSignupData, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        verify: async (options = {}) => {
            const localVarPath = `/verify`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication EmailVerificationToken required
            await setApiKeyToObject(localVarQueryParameter, "token", configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * AuthApi - functional programming interface
 * @export
 */
export const AuthApiFp = function (configuration) {
    const localVarAxiosParamCreator = AuthApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @param {PasswordChangeData} passwordChangeData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createPasswordChange(passwordChangeData, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createPasswordChange(passwordChangeData, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createToken(options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createToken(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {EmailVerificationData} emailVerificationData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createVerification(emailVerificationData, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createVerification(emailVerificationData, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async login(options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.login(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async logout(options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.logout(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {SetPasswordData} setPasswordData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async setPassword(setPasswordData, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.setPassword(setPasswordData, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {SignupData} signupData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async signup(signupData, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.signup(signupData, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {PartialSignupData} partialSignupData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async validateSignup(partialSignupData, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.validateSignup(partialSignupData, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async verify(options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.verify(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    };
};
/**
 * AuthApi - factory interface
 * @export
 */
export const AuthApiFactory = function (configuration, basePath, axios) {
    const localVarFp = AuthApiFp(configuration);
    return {
        /**
         *
         * @param {PasswordChangeData} passwordChangeData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPasswordChange(passwordChangeData, options) {
            return localVarFp.createPasswordChange(passwordChangeData, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createToken(options) {
            return localVarFp.createToken(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {EmailVerificationData} emailVerificationData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createVerification(emailVerificationData, options) {
            return localVarFp.createVerification(emailVerificationData, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        login(options) {
            return localVarFp.login(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        logout(options) {
            return localVarFp.logout(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {SetPasswordData} setPasswordData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setPassword(setPasswordData, options) {
            return localVarFp.setPassword(setPasswordData, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {SignupData} signupData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        signup(signupData, options) {
            return localVarFp.signup(signupData, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {PartialSignupData} partialSignupData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateSignup(partialSignupData, options) {
            return localVarFp.validateSignup(partialSignupData, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        verify(options) {
            return localVarFp.verify(options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * AuthApi - object-oriented interface
 * @export
 * @class AuthApi
 * @extends {BaseAPI}
 */
export class AuthApi extends BaseAPI {
    /**
     *
     * @param {AuthApiCreatePasswordChangeRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthApi
     */
    createPasswordChange(requestParameters, options) {
        return AuthApiFp(this.configuration).createPasswordChange(requestParameters.passwordChangeData, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthApi
     */
    createToken(options) {
        return AuthApiFp(this.configuration).createToken(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {AuthApiCreateVerificationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthApi
     */
    createVerification(requestParameters, options) {
        return AuthApiFp(this.configuration).createVerification(requestParameters.emailVerificationData, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthApi
     */
    login(options) {
        return AuthApiFp(this.configuration).login(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthApi
     */
    logout(options) {
        return AuthApiFp(this.configuration).logout(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {AuthApiSetPasswordRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthApi
     */
    setPassword(requestParameters, options) {
        return AuthApiFp(this.configuration).setPassword(requestParameters.setPasswordData, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {AuthApiSignupRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthApi
     */
    signup(requestParameters, options) {
        return AuthApiFp(this.configuration).signup(requestParameters.signupData, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {AuthApiValidateSignupRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthApi
     */
    validateSignup(requestParameters, options) {
        return AuthApiFp(this.configuration).validateSignup(requestParameters.partialSignupData, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthApi
     */
    verify(options) {
        return AuthApiFp(this.configuration).verify(options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * BidApi - axios parameter creator
 * @export
 */
export const BidApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {string} id
         * @param {Array<BidInclude>} [include]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBid: async (id, include, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getBid', 'id', id);
            const localVarPath = `/bid/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication AccessToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (include) {
                localVarQueryParameter['include'] = include;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} [limit]
         * @param {number} [offset]
         * @param {BidSort} [sort]
         * @param {Array<BidInclude>} [include]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listBid: async (limit, offset, sort, include, options = {}) => {
            const localVarPath = `/bid`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication AccessToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }
            if (sort !== undefined) {
                localVarQueryParameter['sort'] = sort;
            }
            if (include) {
                localVarQueryParameter['include'] = include;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * BidApi - functional programming interface
 * @export
 */
export const BidApiFp = function (configuration) {
    const localVarAxiosParamCreator = BidApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @param {string} id
         * @param {Array<BidInclude>} [include]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getBid(id, include, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getBid(id, include, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {number} [limit]
         * @param {number} [offset]
         * @param {BidSort} [sort]
         * @param {Array<BidInclude>} [include]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listBid(limit, offset, sort, include, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listBid(limit, offset, sort, include, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    };
};
/**
 * BidApi - factory interface
 * @export
 */
export const BidApiFactory = function (configuration, basePath, axios) {
    const localVarFp = BidApiFp(configuration);
    return {
        /**
         *
         * @param {string} id
         * @param {Array<BidInclude>} [include]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBid(id, include, options) {
            return localVarFp.getBid(id, include, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} [limit]
         * @param {number} [offset]
         * @param {BidSort} [sort]
         * @param {Array<BidInclude>} [include]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listBid(limit, offset, sort, include, options) {
            return localVarFp.listBid(limit, offset, sort, include, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * BidApi - object-oriented interface
 * @export
 * @class BidApi
 * @extends {BaseAPI}
 */
export class BidApi extends BaseAPI {
    /**
     *
     * @param {BidApiGetBidRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BidApi
     */
    getBid(requestParameters, options) {
        return BidApiFp(this.configuration).getBid(requestParameters.id, requestParameters.include, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {BidApiListBidRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BidApi
     */
    listBid(requestParameters = {}, options) {
        return BidApiFp(this.configuration).listBid(requestParameters.limit, requestParameters.offset, requestParameters.sort, requestParameters.include, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * CollectionsApi - axios parameter creator
 * @export
 */
export const CollectionsApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {CollectionCreateData} collectionCreateData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCollection: async (collectionCreateData, options = {}) => {
            // verify required parameter 'collectionCreateData' is not null or undefined
            assertParamExists('createCollection', 'collectionCreateData', collectionCreateData);
            const localVarPath = `/collections`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication AccessToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(collectionCreateData, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {FileCreateData} fileCreateData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createFileUpload: async (fileCreateData, options = {}) => {
            // verify required parameter 'fileCreateData' is not null or undefined
            assertParamExists('createFileUpload', 'fileCreateData', fileCreateData);
            const localVarPath = `/collections/create-file-upload`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication AccessToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(fileCreateData, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteCollection: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteCollection', 'id', id);
            const localVarPath = `/collections/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication AccessToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} nftContractAddress
         * @param {Network} network
         * @param {string} [slug]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAdminPreviewUnlockableContent: async (nftContractAddress, network, slug, options = {}) => {
            // verify required parameter 'nftContractAddress' is not null or undefined
            assertParamExists('getAdminPreviewUnlockableContent', 'nftContractAddress', nftContractAddress);
            // verify required parameter 'network' is not null or undefined
            assertParamExists('getAdminPreviewUnlockableContent', 'network', network);
            const localVarPath = `/collections/admin/preview/{nftContractAddress}`
                .replace(`{${"nftContractAddress"}}`, encodeURIComponent(String(nftContractAddress)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication AccessToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (network !== undefined) {
                localVarQueryParameter['network'] = network;
            }
            if (slug !== undefined) {
                localVarQueryParameter['slug'] = slug;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCollection: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getCollection', 'id', id);
            const localVarPath = `/collections/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication AccessToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCollectionAdmin: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getCollectionAdmin', 'id', id);
            const localVarPath = `/collections/admin/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication AccessToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} contractAddress
         * @param {Network} [network]
         * @param {string} [slug]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCollectionByAddress: async (contractAddress, network, slug, options = {}) => {
            // verify required parameter 'contractAddress' is not null or undefined
            assertParamExists('getCollectionByAddress', 'contractAddress', contractAddress);
            const localVarPath = `/collections/address/{contractAddress}`
                .replace(`{${"contractAddress"}}`, encodeURIComponent(String(contractAddress)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (network !== undefined) {
                localVarQueryParameter['network'] = network;
            }
            if (slug !== undefined) {
                localVarQueryParameter['slug'] = slug;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} addressOrSlug
         * @param {Network} [network]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCollectionByAddressOrSlug: async (addressOrSlug, network, options = {}) => {
            // verify required parameter 'addressOrSlug' is not null or undefined
            assertParamExists('getCollectionByAddressOrSlug', 'addressOrSlug', addressOrSlug);
            const localVarPath = `/collections/addressOrSlug/{addressOrSlug}`
                .replace(`{${"addressOrSlug"}}`, encodeURIComponent(String(addressOrSlug)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (network !== undefined) {
                localVarQueryParameter['network'] = network;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} nftContractAddress
         * @param {string} nftId
         * @param {string} address
         * @param {string} hashedMessage
         * @param {Network} network
         * @param {string} [slug]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUnlockableContentIfValid: async (nftContractAddress, nftId, address, hashedMessage, network, slug, options = {}) => {
            // verify required parameter 'nftContractAddress' is not null or undefined
            assertParamExists('getUnlockableContentIfValid', 'nftContractAddress', nftContractAddress);
            // verify required parameter 'nftId' is not null or undefined
            assertParamExists('getUnlockableContentIfValid', 'nftId', nftId);
            // verify required parameter 'address' is not null or undefined
            assertParamExists('getUnlockableContentIfValid', 'address', address);
            // verify required parameter 'hashedMessage' is not null or undefined
            assertParamExists('getUnlockableContentIfValid', 'hashedMessage', hashedMessage);
            // verify required parameter 'network' is not null or undefined
            assertParamExists('getUnlockableContentIfValid', 'network', network);
            const localVarPath = `/collections/{nftContractAddress}/{nftId}/{address}/{hashedMessage}`
                .replace(`{${"nftContractAddress"}}`, encodeURIComponent(String(nftContractAddress)))
                .replace(`{${"nftId"}}`, encodeURIComponent(String(nftId)))
                .replace(`{${"address"}}`, encodeURIComponent(String(address)))
                .replace(`{${"hashedMessage"}}`, encodeURIComponent(String(hashedMessage)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (network !== undefined) {
                localVarQueryParameter['network'] = network;
            }
            if (slug !== undefined) {
                localVarQueryParameter['slug'] = slug;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} contractAddress
         * @param {Network} [network]
         * @param {string} [slug]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        hasUnlockableContent: async (contractAddress, network, slug, options = {}) => {
            // verify required parameter 'contractAddress' is not null or undefined
            assertParamExists('hasUnlockableContent', 'contractAddress', contractAddress);
            const localVarPath = `/collections/collectionAddress/{contractAddress}`
                .replace(`{${"contractAddress"}}`, encodeURIComponent(String(contractAddress)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (network !== undefined) {
                localVarQueryParameter['network'] = network;
            }
            if (slug !== undefined) {
                localVarQueryParameter['slug'] = slug;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {FileCreateData} fileCreateData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        imageUpload: async (fileCreateData, options = {}) => {
            // verify required parameter 'fileCreateData' is not null or undefined
            assertParamExists('imageUpload', 'fileCreateData', fileCreateData);
            const localVarPath = `/collections/image-upload`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication AccessToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(fileCreateData, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        indexAllCollections: async (options = {}) => {
            const localVarPath = `/collections/indexAllCollections`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication AccessToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} [limit]
         * @param {number} [offset]
         * @param {CollectionSort} [sort]
         * @param {Array<Network>} [network]
         * @param {boolean} [isFeatured]
         * @param {boolean} [indexed]
         * @param {string} [searchQuery]
         * @param {boolean} [hasWhitelistAddresses]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listCollections: async (limit, offset, sort, network, isFeatured, indexed, searchQuery, hasWhitelistAddresses, options = {}) => {
            const localVarPath = `/collections`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }
            if (sort !== undefined) {
                localVarQueryParameter['sort'] = sort;
            }
            if (network) {
                localVarQueryParameter['network'] = network;
            }
            if (isFeatured !== undefined) {
                localVarQueryParameter['isFeatured'] = isFeatured;
            }
            if (indexed !== undefined) {
                localVarQueryParameter['indexed'] = indexed;
            }
            if (searchQuery !== undefined) {
                localVarQueryParameter['searchQuery'] = searchQuery;
            }
            if (hasWhitelistAddresses !== undefined) {
                localVarQueryParameter['hasWhitelistAddresses'] = hasWhitelistAddresses;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} id
         * @param {CollectionUpdateData} collectionUpdateData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCollection: async (id, collectionUpdateData, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateCollection', 'id', id);
            // verify required parameter 'collectionUpdateData' is not null or undefined
            assertParamExists('updateCollection', 'collectionUpdateData', collectionUpdateData);
            const localVarPath = `/collections/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication AccessToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(collectionUpdateData, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * CollectionsApi - functional programming interface
 * @export
 */
export const CollectionsApiFp = function (configuration) {
    const localVarAxiosParamCreator = CollectionsApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @param {CollectionCreateData} collectionCreateData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createCollection(collectionCreateData, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createCollection(collectionCreateData, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {FileCreateData} fileCreateData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createFileUpload(fileCreateData, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createFileUpload(fileCreateData, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteCollection(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteCollection(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {string} nftContractAddress
         * @param {Network} network
         * @param {string} [slug]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAdminPreviewUnlockableContent(nftContractAddress, network, slug, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAdminPreviewUnlockableContent(nftContractAddress, network, slug, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCollection(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCollection(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCollectionAdmin(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCollectionAdmin(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {string} contractAddress
         * @param {Network} [network]
         * @param {string} [slug]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCollectionByAddress(contractAddress, network, slug, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCollectionByAddress(contractAddress, network, slug, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {string} addressOrSlug
         * @param {Network} [network]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCollectionByAddressOrSlug(addressOrSlug, network, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCollectionByAddressOrSlug(addressOrSlug, network, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {string} nftContractAddress
         * @param {string} nftId
         * @param {string} address
         * @param {string} hashedMessage
         * @param {Network} network
         * @param {string} [slug]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getUnlockableContentIfValid(nftContractAddress, nftId, address, hashedMessage, network, slug, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getUnlockableContentIfValid(nftContractAddress, nftId, address, hashedMessage, network, slug, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {string} contractAddress
         * @param {Network} [network]
         * @param {string} [slug]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async hasUnlockableContent(contractAddress, network, slug, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.hasUnlockableContent(contractAddress, network, slug, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {FileCreateData} fileCreateData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async imageUpload(fileCreateData, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.imageUpload(fileCreateData, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async indexAllCollections(options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.indexAllCollections(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {number} [limit]
         * @param {number} [offset]
         * @param {CollectionSort} [sort]
         * @param {Array<Network>} [network]
         * @param {boolean} [isFeatured]
         * @param {boolean} [indexed]
         * @param {string} [searchQuery]
         * @param {boolean} [hasWhitelistAddresses]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listCollections(limit, offset, sort, network, isFeatured, indexed, searchQuery, hasWhitelistAddresses, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listCollections(limit, offset, sort, network, isFeatured, indexed, searchQuery, hasWhitelistAddresses, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {string} id
         * @param {CollectionUpdateData} collectionUpdateData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateCollection(id, collectionUpdateData, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateCollection(id, collectionUpdateData, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    };
};
/**
 * CollectionsApi - factory interface
 * @export
 */
export const CollectionsApiFactory = function (configuration, basePath, axios) {
    const localVarFp = CollectionsApiFp(configuration);
    return {
        /**
         *
         * @param {CollectionCreateData} collectionCreateData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCollection(collectionCreateData, options) {
            return localVarFp.createCollection(collectionCreateData, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {FileCreateData} fileCreateData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createFileUpload(fileCreateData, options) {
            return localVarFp.createFileUpload(fileCreateData, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteCollection(id, options) {
            return localVarFp.deleteCollection(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} nftContractAddress
         * @param {Network} network
         * @param {string} [slug]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAdminPreviewUnlockableContent(nftContractAddress, network, slug, options) {
            return localVarFp.getAdminPreviewUnlockableContent(nftContractAddress, network, slug, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCollection(id, options) {
            return localVarFp.getCollection(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCollectionAdmin(id, options) {
            return localVarFp.getCollectionAdmin(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} contractAddress
         * @param {Network} [network]
         * @param {string} [slug]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCollectionByAddress(contractAddress, network, slug, options) {
            return localVarFp.getCollectionByAddress(contractAddress, network, slug, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} addressOrSlug
         * @param {Network} [network]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCollectionByAddressOrSlug(addressOrSlug, network, options) {
            return localVarFp.getCollectionByAddressOrSlug(addressOrSlug, network, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} nftContractAddress
         * @param {string} nftId
         * @param {string} address
         * @param {string} hashedMessage
         * @param {Network} network
         * @param {string} [slug]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUnlockableContentIfValid(nftContractAddress, nftId, address, hashedMessage, network, slug, options) {
            return localVarFp.getUnlockableContentIfValid(nftContractAddress, nftId, address, hashedMessage, network, slug, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} contractAddress
         * @param {Network} [network]
         * @param {string} [slug]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        hasUnlockableContent(contractAddress, network, slug, options) {
            return localVarFp.hasUnlockableContent(contractAddress, network, slug, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {FileCreateData} fileCreateData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        imageUpload(fileCreateData, options) {
            return localVarFp.imageUpload(fileCreateData, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        indexAllCollections(options) {
            return localVarFp.indexAllCollections(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} [limit]
         * @param {number} [offset]
         * @param {CollectionSort} [sort]
         * @param {Array<Network>} [network]
         * @param {boolean} [isFeatured]
         * @param {boolean} [indexed]
         * @param {string} [searchQuery]
         * @param {boolean} [hasWhitelistAddresses]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listCollections(limit, offset, sort, network, isFeatured, indexed, searchQuery, hasWhitelistAddresses, options) {
            return localVarFp.listCollections(limit, offset, sort, network, isFeatured, indexed, searchQuery, hasWhitelistAddresses, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} id
         * @param {CollectionUpdateData} collectionUpdateData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCollection(id, collectionUpdateData, options) {
            return localVarFp.updateCollection(id, collectionUpdateData, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * CollectionsApi - object-oriented interface
 * @export
 * @class CollectionsApi
 * @extends {BaseAPI}
 */
export class CollectionsApi extends BaseAPI {
    /**
     *
     * @param {CollectionsApiCreateCollectionRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CollectionsApi
     */
    createCollection(requestParameters, options) {
        return CollectionsApiFp(this.configuration).createCollection(requestParameters.collectionCreateData, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {CollectionsApiCreateFileUploadRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CollectionsApi
     */
    createFileUpload(requestParameters, options) {
        return CollectionsApiFp(this.configuration).createFileUpload(requestParameters.fileCreateData, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {CollectionsApiDeleteCollectionRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CollectionsApi
     */
    deleteCollection(requestParameters, options) {
        return CollectionsApiFp(this.configuration).deleteCollection(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {CollectionsApiGetAdminPreviewUnlockableContentRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CollectionsApi
     */
    getAdminPreviewUnlockableContent(requestParameters, options) {
        return CollectionsApiFp(this.configuration).getAdminPreviewUnlockableContent(requestParameters.nftContractAddress, requestParameters.network, requestParameters.slug, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {CollectionsApiGetCollectionRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CollectionsApi
     */
    getCollection(requestParameters, options) {
        return CollectionsApiFp(this.configuration).getCollection(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {CollectionsApiGetCollectionAdminRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CollectionsApi
     */
    getCollectionAdmin(requestParameters, options) {
        return CollectionsApiFp(this.configuration).getCollectionAdmin(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {CollectionsApiGetCollectionByAddressRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CollectionsApi
     */
    getCollectionByAddress(requestParameters, options) {
        return CollectionsApiFp(this.configuration).getCollectionByAddress(requestParameters.contractAddress, requestParameters.network, requestParameters.slug, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {CollectionsApiGetCollectionByAddressOrSlugRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CollectionsApi
     */
    getCollectionByAddressOrSlug(requestParameters, options) {
        return CollectionsApiFp(this.configuration).getCollectionByAddressOrSlug(requestParameters.addressOrSlug, requestParameters.network, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {CollectionsApiGetUnlockableContentIfValidRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CollectionsApi
     */
    getUnlockableContentIfValid(requestParameters, options) {
        return CollectionsApiFp(this.configuration).getUnlockableContentIfValid(requestParameters.nftContractAddress, requestParameters.nftId, requestParameters.address, requestParameters.hashedMessage, requestParameters.network, requestParameters.slug, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {CollectionsApiHasUnlockableContentRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CollectionsApi
     */
    hasUnlockableContent(requestParameters, options) {
        return CollectionsApiFp(this.configuration).hasUnlockableContent(requestParameters.contractAddress, requestParameters.network, requestParameters.slug, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {CollectionsApiImageUploadRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CollectionsApi
     */
    imageUpload(requestParameters, options) {
        return CollectionsApiFp(this.configuration).imageUpload(requestParameters.fileCreateData, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CollectionsApi
     */
    indexAllCollections(options) {
        return CollectionsApiFp(this.configuration).indexAllCollections(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {CollectionsApiListCollectionsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CollectionsApi
     */
    listCollections(requestParameters = {}, options) {
        return CollectionsApiFp(this.configuration).listCollections(requestParameters.limit, requestParameters.offset, requestParameters.sort, requestParameters.network, requestParameters.isFeatured, requestParameters.indexed, requestParameters.searchQuery, requestParameters.hasWhitelistAddresses, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {CollectionsApiUpdateCollectionRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CollectionsApi
     */
    updateCollection(requestParameters, options) {
        return CollectionsApiFp(this.configuration).updateCollection(requestParameters.id, requestParameters.collectionUpdateData, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * EmailApi - axios parameter creator
 * @export
 */
export const EmailApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addNotify: async (options = {}) => {
            const localVarPath = `/email/addnotify`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication AccessToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} email
         * @param {EmailNotificationData} emailNotificationData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addNotifyByEmail: async (email, emailNotificationData, options = {}) => {
            // verify required parameter 'email' is not null or undefined
            assertParamExists('addNotifyByEmail', 'email', email);
            // verify required parameter 'emailNotificationData' is not null or undefined
            assertParamExists('addNotifyByEmail', 'emailNotificationData', emailNotificationData);
            const localVarPath = `/email/addNotifyByEmail/{email}`
                .replace(`{${"email"}}`, encodeURIComponent(String(email)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(emailNotificationData, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checkIfExist: async (options = {}) => {
            const localVarPath = `/email/checkifexist`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication AccessToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        notify: async (options = {}) => {
            const localVarPath = `/email/notify`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication AccessToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeNotify: async (options = {}) => {
            const localVarPath = `/email/removenotify`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication AccessToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * EmailApi - functional programming interface
 * @export
 */
export const EmailApiFp = function (configuration) {
    const localVarAxiosParamCreator = EmailApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addNotify(options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addNotify(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {string} email
         * @param {EmailNotificationData} emailNotificationData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addNotifyByEmail(email, emailNotificationData, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addNotifyByEmail(email, emailNotificationData, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async checkIfExist(options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.checkIfExist(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async notify(options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.notify(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async removeNotify(options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.removeNotify(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    };
};
/**
 * EmailApi - factory interface
 * @export
 */
export const EmailApiFactory = function (configuration, basePath, axios) {
    const localVarFp = EmailApiFp(configuration);
    return {
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addNotify(options) {
            return localVarFp.addNotify(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} email
         * @param {EmailNotificationData} emailNotificationData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addNotifyByEmail(email, emailNotificationData, options) {
            return localVarFp.addNotifyByEmail(email, emailNotificationData, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checkIfExist(options) {
            return localVarFp.checkIfExist(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        notify(options) {
            return localVarFp.notify(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeNotify(options) {
            return localVarFp.removeNotify(options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * EmailApi - object-oriented interface
 * @export
 * @class EmailApi
 * @extends {BaseAPI}
 */
export class EmailApi extends BaseAPI {
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmailApi
     */
    addNotify(options) {
        return EmailApiFp(this.configuration).addNotify(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {EmailApiAddNotifyByEmailRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmailApi
     */
    addNotifyByEmail(requestParameters, options) {
        return EmailApiFp(this.configuration).addNotifyByEmail(requestParameters.email, requestParameters.emailNotificationData, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmailApi
     */
    checkIfExist(options) {
        return EmailApiFp(this.configuration).checkIfExist(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmailApi
     */
    notify(options) {
        return EmailApiFp(this.configuration).notify(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmailApi
     */
    removeNotify(options) {
        return EmailApiFp(this.configuration).removeNotify(options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * EventsApi - axios parameter creator
 * @export
 */
export const EventsApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {number} [limit]
         * @param {number} [offset]
         * @param {PostSort} [sort]
         * @param {boolean} [futureOnly]
         * @param {Array<PostInclude>} [include]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listEvents: async (limit, offset, sort, futureOnly, include, options = {}) => {
            const localVarPath = `/events`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication AccessToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }
            if (sort !== undefined) {
                localVarQueryParameter['sort'] = sort;
            }
            if (futureOnly !== undefined) {
                localVarQueryParameter['futureOnly'] = futureOnly;
            }
            if (include) {
                localVarQueryParameter['include'] = include;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * EventsApi - functional programming interface
 * @export
 */
export const EventsApiFp = function (configuration) {
    const localVarAxiosParamCreator = EventsApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @param {number} [limit]
         * @param {number} [offset]
         * @param {PostSort} [sort]
         * @param {boolean} [futureOnly]
         * @param {Array<PostInclude>} [include]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listEvents(limit, offset, sort, futureOnly, include, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listEvents(limit, offset, sort, futureOnly, include, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    };
};
/**
 * EventsApi - factory interface
 * @export
 */
export const EventsApiFactory = function (configuration, basePath, axios) {
    const localVarFp = EventsApiFp(configuration);
    return {
        /**
         *
         * @param {number} [limit]
         * @param {number} [offset]
         * @param {PostSort} [sort]
         * @param {boolean} [futureOnly]
         * @param {Array<PostInclude>} [include]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listEvents(limit, offset, sort, futureOnly, include, options) {
            return localVarFp.listEvents(limit, offset, sort, futureOnly, include, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * EventsApi - object-oriented interface
 * @export
 * @class EventsApi
 * @extends {BaseAPI}
 */
export class EventsApi extends BaseAPI {
    /**
     *
     * @param {EventsApiListEventsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EventsApi
     */
    listEvents(requestParameters = {}, options) {
        return EventsApiFp(this.configuration).listEvents(requestParameters.limit, requestParameters.offset, requestParameters.sort, requestParameters.futureOnly, requestParameters.include, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * FaqApi - axios parameter creator
 * @export
 */
export const FaqApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {CreateFaqData} createFaqData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createFaq: async (createFaqData, options = {}) => {
            // verify required parameter 'createFaqData' is not null or undefined
            assertParamExists('createFaq', 'createFaqData', createFaqData);
            const localVarPath = `/faq/create`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication AccessToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(createFaqData, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteFaq: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteFaq', 'id', id);
            const localVarPath = `/faq/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication AccessToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFaq: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getFaq', 'id', id);
            const localVarPath = `/faq/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} id
         * @param {UpdateFaqData} updateFaqData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateFaq: async (id, updateFaqData, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateFaq', 'id', id);
            // verify required parameter 'updateFaqData' is not null or undefined
            assertParamExists('updateFaq', 'updateFaqData', updateFaqData);
            const localVarPath = `/faq/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication AccessToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(updateFaqData, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * FaqApi - functional programming interface
 * @export
 */
export const FaqApiFp = function (configuration) {
    const localVarAxiosParamCreator = FaqApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @param {CreateFaqData} createFaqData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createFaq(createFaqData, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createFaq(createFaqData, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteFaq(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteFaq(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getFaq(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getFaq(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {string} id
         * @param {UpdateFaqData} updateFaqData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateFaq(id, updateFaqData, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateFaq(id, updateFaqData, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    };
};
/**
 * FaqApi - factory interface
 * @export
 */
export const FaqApiFactory = function (configuration, basePath, axios) {
    const localVarFp = FaqApiFp(configuration);
    return {
        /**
         *
         * @param {CreateFaqData} createFaqData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createFaq(createFaqData, options) {
            return localVarFp.createFaq(createFaqData, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteFaq(id, options) {
            return localVarFp.deleteFaq(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFaq(id, options) {
            return localVarFp.getFaq(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} id
         * @param {UpdateFaqData} updateFaqData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateFaq(id, updateFaqData, options) {
            return localVarFp.updateFaq(id, updateFaqData, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * FaqApi - object-oriented interface
 * @export
 * @class FaqApi
 * @extends {BaseAPI}
 */
export class FaqApi extends BaseAPI {
    /**
     *
     * @param {FaqApiCreateFaqRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FaqApi
     */
    createFaq(requestParameters, options) {
        return FaqApiFp(this.configuration).createFaq(requestParameters.createFaqData, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {FaqApiDeleteFaqRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FaqApi
     */
    deleteFaq(requestParameters, options) {
        return FaqApiFp(this.configuration).deleteFaq(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {FaqApiGetFaqRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FaqApi
     */
    getFaq(requestParameters, options) {
        return FaqApiFp(this.configuration).getFaq(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {FaqApiUpdateFaqRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FaqApi
     */
    updateFaq(requestParameters, options) {
        return FaqApiFp(this.configuration).updateFaq(requestParameters.id, requestParameters.updateFaqData, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * FileApi - axios parameter creator
 * @export
 */
export const FileApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {number} [limit]
         * @param {number} [offset]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listFiles: async (limit, offset, options = {}) => {
            const localVarPath = `/file`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * FileApi - functional programming interface
 * @export
 */
export const FileApiFp = function (configuration) {
    const localVarAxiosParamCreator = FileApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @param {number} [limit]
         * @param {number} [offset]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listFiles(limit, offset, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listFiles(limit, offset, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    };
};
/**
 * FileApi - factory interface
 * @export
 */
export const FileApiFactory = function (configuration, basePath, axios) {
    const localVarFp = FileApiFp(configuration);
    return {
        /**
         *
         * @param {number} [limit]
         * @param {number} [offset]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listFiles(limit, offset, options) {
            return localVarFp.listFiles(limit, offset, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * FileApi - object-oriented interface
 * @export
 * @class FileApi
 * @extends {BaseAPI}
 */
export class FileApi extends BaseAPI {
    /**
     *
     * @param {FileApiListFilesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FileApi
     */
    listFiles(requestParameters = {}, options) {
        return FileApiFp(this.configuration).listFiles(requestParameters.limit, requestParameters.offset, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * LaunchPadApi - axios parameter creator
 * @export
 */
export const LaunchPadApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {FileCreateData} fileCreateData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createFileUpload: async (fileCreateData, options = {}) => {
            // verify required parameter 'fileCreateData' is not null or undefined
            assertParamExists('createFileUpload', 'fileCreateData', fileCreateData);
            const localVarPath = `/launchPad/create-file-upload`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication AccessToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(fileCreateData, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {CreateLaunchPadData} createLaunchPadData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createLaunchPad: async (createLaunchPadData, options = {}) => {
            // verify required parameter 'createLaunchPadData' is not null or undefined
            assertParamExists('createLaunchPad', 'createLaunchPadData', createLaunchPadData);
            const localVarPath = `/launchPad`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication AccessToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(createLaunchPadData, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteLaunchPad: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteLaunchPad', 'id', id);
            const localVarPath = `/launchPad/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication AccessToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLaunchPad: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getLaunchPad', 'id', id);
            const localVarPath = `/launchPad/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLaunchPadFromCollection: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getLaunchPadFromCollection', 'id', id);
            const localVarPath = `/launchPad/collectionId/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} slug
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLaunchPadFromCollectionSlug: async (slug, options = {}) => {
            // verify required parameter 'slug' is not null or undefined
            assertParamExists('getLaunchPadFromCollectionSlug', 'slug', slug);
            const localVarPath = `/launchPad/collectionSlug/{slug}`
                .replace(`{${"slug"}}`, encodeURIComponent(String(slug)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        indexAllLaunchpads: async (options = {}) => {
            const localVarPath = `/launchPad/indexAllLaunchpads`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication AccessToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} [limit]
         * @param {number} [offset]
         * @param {LaunchPadSort} [sort]
         * @param {boolean} [isFeatured]
         * @param {boolean} [indexed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listLaunchPads: async (limit, offset, sort, isFeatured, indexed, options = {}) => {
            const localVarPath = `/launchPad`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }
            if (sort !== undefined) {
                localVarQueryParameter['sort'] = sort;
            }
            if (isFeatured !== undefined) {
                localVarQueryParameter['isFeatured'] = isFeatured;
            }
            if (indexed !== undefined) {
                localVarQueryParameter['indexed'] = indexed;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} id
         * @param {UpdateLaunchPadData} updateLaunchPadData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateLaunchPad: async (id, updateLaunchPadData, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateLaunchPad', 'id', id);
            // verify required parameter 'updateLaunchPadData' is not null or undefined
            assertParamExists('updateLaunchPad', 'updateLaunchPadData', updateLaunchPadData);
            const localVarPath = `/launchPad/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication AccessToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(updateLaunchPadData, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * LaunchPadApi - functional programming interface
 * @export
 */
export const LaunchPadApiFp = function (configuration) {
    const localVarAxiosParamCreator = LaunchPadApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @param {FileCreateData} fileCreateData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createFileUpload(fileCreateData, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createFileUpload(fileCreateData, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {CreateLaunchPadData} createLaunchPadData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createLaunchPad(createLaunchPadData, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createLaunchPad(createLaunchPadData, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteLaunchPad(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteLaunchPad(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getLaunchPad(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getLaunchPad(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getLaunchPadFromCollection(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getLaunchPadFromCollection(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {string} slug
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getLaunchPadFromCollectionSlug(slug, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getLaunchPadFromCollectionSlug(slug, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async indexAllLaunchpads(options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.indexAllLaunchpads(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {number} [limit]
         * @param {number} [offset]
         * @param {LaunchPadSort} [sort]
         * @param {boolean} [isFeatured]
         * @param {boolean} [indexed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listLaunchPads(limit, offset, sort, isFeatured, indexed, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listLaunchPads(limit, offset, sort, isFeatured, indexed, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {string} id
         * @param {UpdateLaunchPadData} updateLaunchPadData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateLaunchPad(id, updateLaunchPadData, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateLaunchPad(id, updateLaunchPadData, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    };
};
/**
 * LaunchPadApi - factory interface
 * @export
 */
export const LaunchPadApiFactory = function (configuration, basePath, axios) {
    const localVarFp = LaunchPadApiFp(configuration);
    return {
        /**
         *
         * @param {FileCreateData} fileCreateData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createFileUpload(fileCreateData, options) {
            return localVarFp.createFileUpload(fileCreateData, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {CreateLaunchPadData} createLaunchPadData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createLaunchPad(createLaunchPadData, options) {
            return localVarFp.createLaunchPad(createLaunchPadData, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteLaunchPad(id, options) {
            return localVarFp.deleteLaunchPad(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLaunchPad(id, options) {
            return localVarFp.getLaunchPad(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLaunchPadFromCollection(id, options) {
            return localVarFp.getLaunchPadFromCollection(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} slug
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLaunchPadFromCollectionSlug(slug, options) {
            return localVarFp.getLaunchPadFromCollectionSlug(slug, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        indexAllLaunchpads(options) {
            return localVarFp.indexAllLaunchpads(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} [limit]
         * @param {number} [offset]
         * @param {LaunchPadSort} [sort]
         * @param {boolean} [isFeatured]
         * @param {boolean} [indexed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listLaunchPads(limit, offset, sort, isFeatured, indexed, options) {
            return localVarFp.listLaunchPads(limit, offset, sort, isFeatured, indexed, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} id
         * @param {UpdateLaunchPadData} updateLaunchPadData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateLaunchPad(id, updateLaunchPadData, options) {
            return localVarFp.updateLaunchPad(id, updateLaunchPadData, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * LaunchPadApi - object-oriented interface
 * @export
 * @class LaunchPadApi
 * @extends {BaseAPI}
 */
export class LaunchPadApi extends BaseAPI {
    /**
     *
     * @param {LaunchPadApiCreateFileUploadRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LaunchPadApi
     */
    createFileUpload(requestParameters, options) {
        return LaunchPadApiFp(this.configuration).createFileUpload(requestParameters.fileCreateData, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {LaunchPadApiCreateLaunchPadRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LaunchPadApi
     */
    createLaunchPad(requestParameters, options) {
        return LaunchPadApiFp(this.configuration).createLaunchPad(requestParameters.createLaunchPadData, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {LaunchPadApiDeleteLaunchPadRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LaunchPadApi
     */
    deleteLaunchPad(requestParameters, options) {
        return LaunchPadApiFp(this.configuration).deleteLaunchPad(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {LaunchPadApiGetLaunchPadRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LaunchPadApi
     */
    getLaunchPad(requestParameters, options) {
        return LaunchPadApiFp(this.configuration).getLaunchPad(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {LaunchPadApiGetLaunchPadFromCollectionRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LaunchPadApi
     */
    getLaunchPadFromCollection(requestParameters, options) {
        return LaunchPadApiFp(this.configuration).getLaunchPadFromCollection(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {LaunchPadApiGetLaunchPadFromCollectionSlugRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LaunchPadApi
     */
    getLaunchPadFromCollectionSlug(requestParameters, options) {
        return LaunchPadApiFp(this.configuration).getLaunchPadFromCollectionSlug(requestParameters.slug, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LaunchPadApi
     */
    indexAllLaunchpads(options) {
        return LaunchPadApiFp(this.configuration).indexAllLaunchpads(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {LaunchPadApiListLaunchPadsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LaunchPadApi
     */
    listLaunchPads(requestParameters = {}, options) {
        return LaunchPadApiFp(this.configuration).listLaunchPads(requestParameters.limit, requestParameters.offset, requestParameters.sort, requestParameters.isFeatured, requestParameters.indexed, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {LaunchPadApiUpdateLaunchPadRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LaunchPadApi
     */
    updateLaunchPad(requestParameters, options) {
        return LaunchPadApiFp(this.configuration).updateLaunchPad(requestParameters.id, requestParameters.updateLaunchPadData, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * ListingApi - axios parameter creator
 * @export
 */
export const ListingApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {string} id
         * @param {string} contractAddress
         * @param {Array<ListingInclude>} [include]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getListing: async (id, contractAddress, include, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getListing', 'id', id);
            // verify required parameter 'contractAddress' is not null or undefined
            assertParamExists('getListing', 'contractAddress', contractAddress);
            const localVarPath = `/listing/{contractAddress}/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"contractAddress"}}`, encodeURIComponent(String(contractAddress)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication AccessToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (include) {
                localVarQueryParameter['include'] = include;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} [limit]
         * @param {number} [offset]
         * @param {ListingSort} [sort]
         * @param {Array<ListingStatus>} [status]
         * @param {Array<ListingInclude>} [include]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listListing: async (limit, offset, sort, status, include, options = {}) => {
            const localVarPath = `/listing`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication AccessToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }
            if (sort !== undefined) {
                localVarQueryParameter['sort'] = sort;
            }
            if (status) {
                localVarQueryParameter['status'] = status;
            }
            if (include) {
                localVarQueryParameter['include'] = include;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * ListingApi - functional programming interface
 * @export
 */
export const ListingApiFp = function (configuration) {
    const localVarAxiosParamCreator = ListingApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @param {string} id
         * @param {string} contractAddress
         * @param {Array<ListingInclude>} [include]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getListing(id, contractAddress, include, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getListing(id, contractAddress, include, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {number} [limit]
         * @param {number} [offset]
         * @param {ListingSort} [sort]
         * @param {Array<ListingStatus>} [status]
         * @param {Array<ListingInclude>} [include]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listListing(limit, offset, sort, status, include, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listListing(limit, offset, sort, status, include, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    };
};
/**
 * ListingApi - factory interface
 * @export
 */
export const ListingApiFactory = function (configuration, basePath, axios) {
    const localVarFp = ListingApiFp(configuration);
    return {
        /**
         *
         * @param {string} id
         * @param {string} contractAddress
         * @param {Array<ListingInclude>} [include]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getListing(id, contractAddress, include, options) {
            return localVarFp.getListing(id, contractAddress, include, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} [limit]
         * @param {number} [offset]
         * @param {ListingSort} [sort]
         * @param {Array<ListingStatus>} [status]
         * @param {Array<ListingInclude>} [include]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listListing(limit, offset, sort, status, include, options) {
            return localVarFp.listListing(limit, offset, sort, status, include, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * ListingApi - object-oriented interface
 * @export
 * @class ListingApi
 * @extends {BaseAPI}
 */
export class ListingApi extends BaseAPI {
    /**
     *
     * @param {ListingApiGetListingRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ListingApi
     */
    getListing(requestParameters, options) {
        return ListingApiFp(this.configuration).getListing(requestParameters.id, requestParameters.contractAddress, requestParameters.include, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {ListingApiListListingRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ListingApi
     */
    listListing(requestParameters = {}, options) {
        return ListingApiFp(this.configuration).listListing(requestParameters.limit, requestParameters.offset, requestParameters.sort, requestParameters.status, requestParameters.include, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * MogiesApi - axios parameter creator
 * @export
 */
export const MogiesApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        _delete: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('_delete', 'id', id);
            const localVarPath = `/mogies/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication AccessToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {MogieCreateData} mogieCreateData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        create: async (mogieCreateData, options = {}) => {
            // verify required parameter 'mogieCreateData' is not null or undefined
            assertParamExists('create', 'mogieCreateData', mogieCreateData);
            const localVarPath = `/mogies`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication AccessToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(mogieCreateData, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        get: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('get', 'id', id);
            const localVarPath = `/mogies/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} [limit]
         * @param {number} [offset]
         * @param {string} [searchQuery]
         * @param {Array<MogieRarity>} [rarity]
         * @param {MogieSort} [sort]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        list: async (limit, offset, searchQuery, rarity, sort, options = {}) => {
            const localVarPath = `/mogies`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }
            if (searchQuery !== undefined) {
                localVarQueryParameter['searchQuery'] = searchQuery;
            }
            if (rarity) {
                localVarQueryParameter['rarity'] = rarity;
            }
            if (sort !== undefined) {
                localVarQueryParameter['sort'] = sort;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} id
         * @param {MogieUpdateData} mogieUpdateData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        update: async (id, mogieUpdateData, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('update', 'id', id);
            // verify required parameter 'mogieUpdateData' is not null or undefined
            assertParamExists('update', 'mogieUpdateData', mogieUpdateData);
            const localVarPath = `/mogies/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication AccessToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(mogieUpdateData, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * MogiesApi - functional programming interface
 * @export
 */
export const MogiesApiFp = function (configuration) {
    const localVarAxiosParamCreator = MogiesApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async _delete(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator._delete(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {MogieCreateData} mogieCreateData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async create(mogieCreateData, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.create(mogieCreateData, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async get(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.get(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {number} [limit]
         * @param {number} [offset]
         * @param {string} [searchQuery]
         * @param {Array<MogieRarity>} [rarity]
         * @param {MogieSort} [sort]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async list(limit, offset, searchQuery, rarity, sort, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.list(limit, offset, searchQuery, rarity, sort, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {string} id
         * @param {MogieUpdateData} mogieUpdateData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async update(id, mogieUpdateData, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.update(id, mogieUpdateData, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    };
};
/**
 * MogiesApi - factory interface
 * @export
 */
export const MogiesApiFactory = function (configuration, basePath, axios) {
    const localVarFp = MogiesApiFp(configuration);
    return {
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        _delete(id, options) {
            return localVarFp._delete(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {MogieCreateData} mogieCreateData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        create(mogieCreateData, options) {
            return localVarFp.create(mogieCreateData, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        get(id, options) {
            return localVarFp.get(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} [limit]
         * @param {number} [offset]
         * @param {string} [searchQuery]
         * @param {Array<MogieRarity>} [rarity]
         * @param {MogieSort} [sort]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        list(limit, offset, searchQuery, rarity, sort, options) {
            return localVarFp.list(limit, offset, searchQuery, rarity, sort, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} id
         * @param {MogieUpdateData} mogieUpdateData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        update(id, mogieUpdateData, options) {
            return localVarFp.update(id, mogieUpdateData, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * MogiesApi - object-oriented interface
 * @export
 * @class MogiesApi
 * @extends {BaseAPI}
 */
export class MogiesApi extends BaseAPI {
    /**
     *
     * @param {MogiesApiDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MogiesApi
     */
    _delete(requestParameters, options) {
        return MogiesApiFp(this.configuration)._delete(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {MogiesApiCreateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MogiesApi
     */
    create(requestParameters, options) {
        return MogiesApiFp(this.configuration).create(requestParameters.mogieCreateData, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {MogiesApiGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MogiesApi
     */
    get(requestParameters, options) {
        return MogiesApiFp(this.configuration).get(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {MogiesApiListRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MogiesApi
     */
    list(requestParameters = {}, options) {
        return MogiesApiFp(this.configuration).list(requestParameters.limit, requestParameters.offset, requestParameters.searchQuery, requestParameters.rarity, requestParameters.sort, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {MogiesApiUpdateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MogiesApi
     */
    update(requestParameters, options) {
        return MogiesApiFp(this.configuration).update(requestParameters.id, requestParameters.mogieUpdateData, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * MoralisApi - axios parameter creator
 * @export
 */
export const MoralisApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {string} address
         * @param {string} chain
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWalletTransactions: async (address, chain, options = {}) => {
            // verify required parameter 'address' is not null or undefined
            assertParamExists('getWalletTransactions', 'address', address);
            // verify required parameter 'chain' is not null or undefined
            assertParamExists('getWalletTransactions', 'chain', chain);
            const localVarPath = `/moralis/transactions`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (address !== undefined) {
                localVarQueryParameter['address'] = address;
            }
            if (chain !== undefined) {
                localVarQueryParameter['chain'] = chain;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * MoralisApi - functional programming interface
 * @export
 */
export const MoralisApiFp = function (configuration) {
    const localVarAxiosParamCreator = MoralisApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @param {string} address
         * @param {string} chain
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getWalletTransactions(address, chain, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getWalletTransactions(address, chain, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    };
};
/**
 * MoralisApi - factory interface
 * @export
 */
export const MoralisApiFactory = function (configuration, basePath, axios) {
    const localVarFp = MoralisApiFp(configuration);
    return {
        /**
         *
         * @param {string} address
         * @param {string} chain
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWalletTransactions(address, chain, options) {
            return localVarFp.getWalletTransactions(address, chain, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * MoralisApi - object-oriented interface
 * @export
 * @class MoralisApi
 * @extends {BaseAPI}
 */
export class MoralisApi extends BaseAPI {
    /**
     *
     * @param {MoralisApiGetWalletTransactionsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MoralisApi
     */
    getWalletTransactions(requestParameters, options) {
        return MoralisApiFp(this.configuration).getWalletTransactions(requestParameters.address, requestParameters.chain, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * NftsApi - axios parameter creator
 * @export
 */
export const NftsApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {number} low
         * @param {number} high
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addHiddenMogies: async (low, high, options = {}) => {
            // verify required parameter 'low' is not null or undefined
            assertParamExists('addHiddenMogies', 'low', low);
            // verify required parameter 'high' is not null or undefined
            assertParamExists('addHiddenMogies', 'high', high);
            const localVarPath = `/nfts/addHiddenMogies`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication AccessToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (low !== undefined) {
                localVarQueryParameter['low'] = low;
            }
            if (high !== undefined) {
                localVarQueryParameter['high'] = high;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {FileCreateData} fileCreateData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createFileUpload: async (fileCreateData, options = {}) => {
            // verify required parameter 'fileCreateData' is not null or undefined
            assertParamExists('createFileUpload', 'fileCreateData', fileCreateData);
            const localVarPath = `/nfts/create-file-upload`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication AccessToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(fileCreateData, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {NftCreateData} nftCreateData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createMintableNft: async (nftCreateData, options = {}) => {
            // verify required parameter 'nftCreateData' is not null or undefined
            assertParamExists('createMintableNft', 'nftCreateData', nftCreateData);
            const localVarPath = `/nfts/mintable`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication AccessToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(nftCreateData, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {NftCreateData} nftCreateData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createNft: async (nftCreateData, options = {}) => {
            // verify required parameter 'nftCreateData' is not null or undefined
            assertParamExists('createNft', 'nftCreateData', nftCreateData);
            const localVarPath = `/nfts`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication AccessToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(nftCreateData, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} id
         * @param {string} contractAddress
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteNft: async (id, contractAddress, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteNft', 'id', id);
            // verify required parameter 'contractAddress' is not null or undefined
            assertParamExists('deleteNft', 'contractAddress', contractAddress);
            const localVarPath = `/nfts/{contractAddress}/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"contractAddress"}}`, encodeURIComponent(String(contractAddress)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication AccessToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} nftContractAddress
         * @param {string} nftId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAdminPreviewUnlockableContent: async (nftContractAddress, nftId, options = {}) => {
            // verify required parameter 'nftContractAddress' is not null or undefined
            assertParamExists('getAdminPreviewUnlockableContent', 'nftContractAddress', nftContractAddress);
            // verify required parameter 'nftId' is not null or undefined
            assertParamExists('getAdminPreviewUnlockableContent', 'nftId', nftId);
            const localVarPath = `/nfts/admin/preview/{nftContractAddress}/{nftId}`
                .replace(`{${"nftContractAddress"}}`, encodeURIComponent(String(nftContractAddress)))
                .replace(`{${"nftId"}}`, encodeURIComponent(String(nftId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication AccessToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} contractAddress
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDeletedNftIds: async (contractAddress, options = {}) => {
            // verify required parameter 'contractAddress' is not null or undefined
            assertParamExists('getDeletedNftIds', 'contractAddress', contractAddress);
            const localVarPath = `/nfts/{contractAddress}/deleted`
                .replace(`{${"contractAddress"}}`, encodeURIComponent(String(contractAddress)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} contractAddress
         * @param {string} id
         * @param {Array<NftInclude>} [include]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNft: async (contractAddress, id, include, options = {}) => {
            // verify required parameter 'contractAddress' is not null or undefined
            assertParamExists('getNft', 'contractAddress', contractAddress);
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getNft', 'id', id);
            const localVarPath = `/nfts/{contractAddress}/{id}`
                .replace(`{${"contractAddress"}}`, encodeURIComponent(String(contractAddress)))
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication AccessToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (include) {
                localVarQueryParameter['include'] = include;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} contractAddress
         * @param {string} id
         * @param {Array<NftInclude>} [include]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNftIfMinted: async (contractAddress, id, include, options = {}) => {
            // verify required parameter 'contractAddress' is not null or undefined
            assertParamExists('getNftIfMinted', 'contractAddress', contractAddress);
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getNftIfMinted', 'id', id);
            const localVarPath = `/nfts/minted/nft/{contractAddress}/{id}`
                .replace(`{${"contractAddress"}}`, encodeURIComponent(String(contractAddress)))
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (include) {
                localVarQueryParameter['include'] = include;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} nftContractAddress
         * @param {string} nftId
         * @param {string} address
         * @param {string} hashedMessage
         * @param {Network} network
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNftUnlockableContentIfValid: async (nftContractAddress, nftId, address, hashedMessage, network, options = {}) => {
            // verify required parameter 'nftContractAddress' is not null or undefined
            assertParamExists('getNftUnlockableContentIfValid', 'nftContractAddress', nftContractAddress);
            // verify required parameter 'nftId' is not null or undefined
            assertParamExists('getNftUnlockableContentIfValid', 'nftId', nftId);
            // verify required parameter 'address' is not null or undefined
            assertParamExists('getNftUnlockableContentIfValid', 'address', address);
            // verify required parameter 'hashedMessage' is not null or undefined
            assertParamExists('getNftUnlockableContentIfValid', 'hashedMessage', hashedMessage);
            // verify required parameter 'network' is not null or undefined
            assertParamExists('getNftUnlockableContentIfValid', 'network', network);
            const localVarPath = `/nfts/contractAddress/{nftContractAddress}/nftId/{nftId}/address/{address}/hashedMessage/{hashedMessage}`
                .replace(`{${"nftContractAddress"}}`, encodeURIComponent(String(nftContractAddress)))
                .replace(`{${"nftId"}}`, encodeURIComponent(String(nftId)))
                .replace(`{${"address"}}`, encodeURIComponent(String(address)))
                .replace(`{${"hashedMessage"}}`, encodeURIComponent(String(hashedMessage)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (network !== undefined) {
                localVarQueryParameter['network'] = network;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} contractAddress
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        hasNftUnlockableContent: async (contractAddress, id, options = {}) => {
            // verify required parameter 'contractAddress' is not null or undefined
            assertParamExists('hasNftUnlockableContent', 'contractAddress', contractAddress);
            // verify required parameter 'id' is not null or undefined
            assertParamExists('hasNftUnlockableContent', 'id', id);
            const localVarPath = `/nfts/collectionAddress/{contractAddress}/id/{id}`
                .replace(`{${"contractAddress"}}`, encodeURIComponent(String(contractAddress)))
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        indexAllNfts: async (options = {}) => {
            const localVarPath = `/nfts/indexAllNfts`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication AccessToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} [limit]
         * @param {number} [offset]
         * @param {NftSort} [sort]
         * @param {Array<NftInclude>} [include]
         * @param {string} [searchQuery]
         * @param {Array<Network>} [network]
         * @param {boolean} [featured]
         * @param {boolean} [trending]
         * @param {string} [contractAddress]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listMintedNfts: async (limit, offset, sort, include, searchQuery, network, featured, trending, contractAddress, options = {}) => {
            const localVarPath = `/nfts`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }
            if (sort !== undefined) {
                localVarQueryParameter['sort'] = sort;
            }
            if (include) {
                localVarQueryParameter['include'] = include;
            }
            if (searchQuery !== undefined) {
                localVarQueryParameter['searchQuery'] = searchQuery;
            }
            if (network) {
                localVarQueryParameter['network'] = network;
            }
            if (featured !== undefined) {
                localVarQueryParameter['featured'] = featured;
            }
            if (trending !== undefined) {
                localVarQueryParameter['trending'] = trending;
            }
            if (contractAddress !== undefined) {
                localVarQueryParameter['contractAddress'] = contractAddress;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} [limit]
         * @param {number} [offset]
         * @param {NftSort} [sort]
         * @param {Array<NftStatus>} [status]
         * @param {Array<NftInclude>} [include]
         * @param {boolean} [featured]
         * @param {boolean} [trending]
         * @param {boolean} [indexed]
         * @param {string} [contractAddress]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listNfts: async (limit, offset, sort, status, include, featured, trending, indexed, contractAddress, options = {}) => {
            const localVarPath = `/nfts/platform/creators/dashboard`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication AccessToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }
            if (sort !== undefined) {
                localVarQueryParameter['sort'] = sort;
            }
            if (status) {
                localVarQueryParameter['status'] = status;
            }
            if (include) {
                localVarQueryParameter['include'] = include;
            }
            if (featured !== undefined) {
                localVarQueryParameter['featured'] = featured;
            }
            if (trending !== undefined) {
                localVarQueryParameter['trending'] = trending;
            }
            if (indexed !== undefined) {
                localVarQueryParameter['indexed'] = indexed;
            }
            if (contractAddress !== undefined) {
                localVarQueryParameter['contractAddress'] = contractAddress;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        queueRepairNfts: async (options = {}) => {
            const localVarPath = `/nfts/queueRepairNfts`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication AccessToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} address
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        queueRepairNftsAddress: async (address, options = {}) => {
            // verify required parameter 'address' is not null or undefined
            assertParamExists('queueRepairNftsAddress', 'address', address);
            const localVarPath = `/nfts/queueRepairNfts/{address}`
                .replace(`{${"address"}}`, encodeURIComponent(String(address)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication AccessToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        repeatableJob: async (options = {}) => {
            const localVarPath = `/nfts/repeatableJob`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication AccessToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} key
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        repeatableJobKey: async (key, options = {}) => {
            // verify required parameter 'key' is not null or undefined
            assertParamExists('repeatableJobKey', 'key', key);
            const localVarPath = `/nfts/repeatableJob/{key}`
                .replace(`{${"key"}}`, encodeURIComponent(String(key)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication AccessToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} contractAddress
         * @param {string} id
         * @param {NftUpdateData} nftUpdateData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateNft: async (contractAddress, id, nftUpdateData, options = {}) => {
            // verify required parameter 'contractAddress' is not null or undefined
            assertParamExists('updateNft', 'contractAddress', contractAddress);
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateNft', 'id', id);
            // verify required parameter 'nftUpdateData' is not null or undefined
            assertParamExists('updateNft', 'nftUpdateData', nftUpdateData);
            const localVarPath = `/nfts/{contractAddress}/{id}`
                .replace(`{${"contractAddress"}}`, encodeURIComponent(String(contractAddress)))
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication AccessToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(nftUpdateData, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} address
         * @param {string} hashedMessage
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        verifySignedMessage: async (address, hashedMessage, options = {}) => {
            // verify required parameter 'address' is not null or undefined
            assertParamExists('verifySignedMessage', 'address', address);
            // verify required parameter 'hashedMessage' is not null or undefined
            assertParamExists('verifySignedMessage', 'hashedMessage', hashedMessage);
            const localVarPath = `/nfts/verifySignedMessage/address/{address}/signed/{hashedMessage}`
                .replace(`{${"address"}}`, encodeURIComponent(String(address)))
                .replace(`{${"hashedMessage"}}`, encodeURIComponent(String(hashedMessage)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * NftsApi - functional programming interface
 * @export
 */
export const NftsApiFp = function (configuration) {
    const localVarAxiosParamCreator = NftsApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @param {number} low
         * @param {number} high
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addHiddenMogies(low, high, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addHiddenMogies(low, high, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {FileCreateData} fileCreateData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createFileUpload(fileCreateData, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createFileUpload(fileCreateData, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {NftCreateData} nftCreateData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createMintableNft(nftCreateData, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createMintableNft(nftCreateData, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {NftCreateData} nftCreateData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createNft(nftCreateData, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createNft(nftCreateData, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {string} id
         * @param {string} contractAddress
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteNft(id, contractAddress, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteNft(id, contractAddress, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {string} nftContractAddress
         * @param {string} nftId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAdminPreviewUnlockableContent(nftContractAddress, nftId, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAdminPreviewUnlockableContent(nftContractAddress, nftId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {string} contractAddress
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDeletedNftIds(contractAddress, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDeletedNftIds(contractAddress, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {string} contractAddress
         * @param {string} id
         * @param {Array<NftInclude>} [include]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getNft(contractAddress, id, include, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getNft(contractAddress, id, include, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {string} contractAddress
         * @param {string} id
         * @param {Array<NftInclude>} [include]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getNftIfMinted(contractAddress, id, include, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getNftIfMinted(contractAddress, id, include, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {string} nftContractAddress
         * @param {string} nftId
         * @param {string} address
         * @param {string} hashedMessage
         * @param {Network} network
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getNftUnlockableContentIfValid(nftContractAddress, nftId, address, hashedMessage, network, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getNftUnlockableContentIfValid(nftContractAddress, nftId, address, hashedMessage, network, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {string} contractAddress
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async hasNftUnlockableContent(contractAddress, id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.hasNftUnlockableContent(contractAddress, id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async indexAllNfts(options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.indexAllNfts(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {number} [limit]
         * @param {number} [offset]
         * @param {NftSort} [sort]
         * @param {Array<NftInclude>} [include]
         * @param {string} [searchQuery]
         * @param {Array<Network>} [network]
         * @param {boolean} [featured]
         * @param {boolean} [trending]
         * @param {string} [contractAddress]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listMintedNfts(limit, offset, sort, include, searchQuery, network, featured, trending, contractAddress, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listMintedNfts(limit, offset, sort, include, searchQuery, network, featured, trending, contractAddress, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {number} [limit]
         * @param {number} [offset]
         * @param {NftSort} [sort]
         * @param {Array<NftStatus>} [status]
         * @param {Array<NftInclude>} [include]
         * @param {boolean} [featured]
         * @param {boolean} [trending]
         * @param {boolean} [indexed]
         * @param {string} [contractAddress]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listNfts(limit, offset, sort, status, include, featured, trending, indexed, contractAddress, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listNfts(limit, offset, sort, status, include, featured, trending, indexed, contractAddress, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async queueRepairNfts(options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.queueRepairNfts(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {string} address
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async queueRepairNftsAddress(address, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.queueRepairNftsAddress(address, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async repeatableJob(options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.repeatableJob(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {string} key
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async repeatableJobKey(key, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.repeatableJobKey(key, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {string} contractAddress
         * @param {string} id
         * @param {NftUpdateData} nftUpdateData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateNft(contractAddress, id, nftUpdateData, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateNft(contractAddress, id, nftUpdateData, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {string} address
         * @param {string} hashedMessage
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async verifySignedMessage(address, hashedMessage, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.verifySignedMessage(address, hashedMessage, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    };
};
/**
 * NftsApi - factory interface
 * @export
 */
export const NftsApiFactory = function (configuration, basePath, axios) {
    const localVarFp = NftsApiFp(configuration);
    return {
        /**
         *
         * @param {number} low
         * @param {number} high
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addHiddenMogies(low, high, options) {
            return localVarFp.addHiddenMogies(low, high, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {FileCreateData} fileCreateData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createFileUpload(fileCreateData, options) {
            return localVarFp.createFileUpload(fileCreateData, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {NftCreateData} nftCreateData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createMintableNft(nftCreateData, options) {
            return localVarFp.createMintableNft(nftCreateData, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {NftCreateData} nftCreateData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createNft(nftCreateData, options) {
            return localVarFp.createNft(nftCreateData, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} id
         * @param {string} contractAddress
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteNft(id, contractAddress, options) {
            return localVarFp.deleteNft(id, contractAddress, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} nftContractAddress
         * @param {string} nftId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAdminPreviewUnlockableContent(nftContractAddress, nftId, options) {
            return localVarFp.getAdminPreviewUnlockableContent(nftContractAddress, nftId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} contractAddress
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDeletedNftIds(contractAddress, options) {
            return localVarFp.getDeletedNftIds(contractAddress, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} contractAddress
         * @param {string} id
         * @param {Array<NftInclude>} [include]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNft(contractAddress, id, include, options) {
            return localVarFp.getNft(contractAddress, id, include, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} contractAddress
         * @param {string} id
         * @param {Array<NftInclude>} [include]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNftIfMinted(contractAddress, id, include, options) {
            return localVarFp.getNftIfMinted(contractAddress, id, include, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} nftContractAddress
         * @param {string} nftId
         * @param {string} address
         * @param {string} hashedMessage
         * @param {Network} network
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNftUnlockableContentIfValid(nftContractAddress, nftId, address, hashedMessage, network, options) {
            return localVarFp.getNftUnlockableContentIfValid(nftContractAddress, nftId, address, hashedMessage, network, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} contractAddress
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        hasNftUnlockableContent(contractAddress, id, options) {
            return localVarFp.hasNftUnlockableContent(contractAddress, id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        indexAllNfts(options) {
            return localVarFp.indexAllNfts(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} [limit]
         * @param {number} [offset]
         * @param {NftSort} [sort]
         * @param {Array<NftInclude>} [include]
         * @param {string} [searchQuery]
         * @param {Array<Network>} [network]
         * @param {boolean} [featured]
         * @param {boolean} [trending]
         * @param {string} [contractAddress]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listMintedNfts(limit, offset, sort, include, searchQuery, network, featured, trending, contractAddress, options) {
            return localVarFp.listMintedNfts(limit, offset, sort, include, searchQuery, network, featured, trending, contractAddress, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} [limit]
         * @param {number} [offset]
         * @param {NftSort} [sort]
         * @param {Array<NftStatus>} [status]
         * @param {Array<NftInclude>} [include]
         * @param {boolean} [featured]
         * @param {boolean} [trending]
         * @param {boolean} [indexed]
         * @param {string} [contractAddress]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listNfts(limit, offset, sort, status, include, featured, trending, indexed, contractAddress, options) {
            return localVarFp.listNfts(limit, offset, sort, status, include, featured, trending, indexed, contractAddress, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        queueRepairNfts(options) {
            return localVarFp.queueRepairNfts(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} address
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        queueRepairNftsAddress(address, options) {
            return localVarFp.queueRepairNftsAddress(address, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        repeatableJob(options) {
            return localVarFp.repeatableJob(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} key
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        repeatableJobKey(key, options) {
            return localVarFp.repeatableJobKey(key, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} contractAddress
         * @param {string} id
         * @param {NftUpdateData} nftUpdateData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateNft(contractAddress, id, nftUpdateData, options) {
            return localVarFp.updateNft(contractAddress, id, nftUpdateData, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} address
         * @param {string} hashedMessage
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        verifySignedMessage(address, hashedMessage, options) {
            return localVarFp.verifySignedMessage(address, hashedMessage, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * NftsApi - object-oriented interface
 * @export
 * @class NftsApi
 * @extends {BaseAPI}
 */
export class NftsApi extends BaseAPI {
    /**
     *
     * @param {NftsApiAddHiddenMogiesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NftsApi
     */
    addHiddenMogies(requestParameters, options) {
        return NftsApiFp(this.configuration).addHiddenMogies(requestParameters.low, requestParameters.high, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {NftsApiCreateFileUploadRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NftsApi
     */
    createFileUpload(requestParameters, options) {
        return NftsApiFp(this.configuration).createFileUpload(requestParameters.fileCreateData, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {NftsApiCreateMintableNftRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NftsApi
     */
    createMintableNft(requestParameters, options) {
        return NftsApiFp(this.configuration).createMintableNft(requestParameters.nftCreateData, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {NftsApiCreateNftRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NftsApi
     */
    createNft(requestParameters, options) {
        return NftsApiFp(this.configuration).createNft(requestParameters.nftCreateData, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {NftsApiDeleteNftRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NftsApi
     */
    deleteNft(requestParameters, options) {
        return NftsApiFp(this.configuration).deleteNft(requestParameters.id, requestParameters.contractAddress, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {NftsApiGetAdminPreviewUnlockableContentRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NftsApi
     */
    getAdminPreviewUnlockableContent(requestParameters, options) {
        return NftsApiFp(this.configuration).getAdminPreviewUnlockableContent(requestParameters.nftContractAddress, requestParameters.nftId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {NftsApiGetDeletedNftIdsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NftsApi
     */
    getDeletedNftIds(requestParameters, options) {
        return NftsApiFp(this.configuration).getDeletedNftIds(requestParameters.contractAddress, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {NftsApiGetNftRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NftsApi
     */
    getNft(requestParameters, options) {
        return NftsApiFp(this.configuration).getNft(requestParameters.contractAddress, requestParameters.id, requestParameters.include, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {NftsApiGetNftIfMintedRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NftsApi
     */
    getNftIfMinted(requestParameters, options) {
        return NftsApiFp(this.configuration).getNftIfMinted(requestParameters.contractAddress, requestParameters.id, requestParameters.include, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {NftsApiGetNftUnlockableContentIfValidRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NftsApi
     */
    getNftUnlockableContentIfValid(requestParameters, options) {
        return NftsApiFp(this.configuration).getNftUnlockableContentIfValid(requestParameters.nftContractAddress, requestParameters.nftId, requestParameters.address, requestParameters.hashedMessage, requestParameters.network, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {NftsApiHasNftUnlockableContentRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NftsApi
     */
    hasNftUnlockableContent(requestParameters, options) {
        return NftsApiFp(this.configuration).hasNftUnlockableContent(requestParameters.contractAddress, requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NftsApi
     */
    indexAllNfts(options) {
        return NftsApiFp(this.configuration).indexAllNfts(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {NftsApiListMintedNftsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NftsApi
     */
    listMintedNfts(requestParameters = {}, options) {
        return NftsApiFp(this.configuration).listMintedNfts(requestParameters.limit, requestParameters.offset, requestParameters.sort, requestParameters.include, requestParameters.searchQuery, requestParameters.network, requestParameters.featured, requestParameters.trending, requestParameters.contractAddress, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {NftsApiListNftsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NftsApi
     */
    listNfts(requestParameters = {}, options) {
        return NftsApiFp(this.configuration).listNfts(requestParameters.limit, requestParameters.offset, requestParameters.sort, requestParameters.status, requestParameters.include, requestParameters.featured, requestParameters.trending, requestParameters.indexed, requestParameters.contractAddress, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NftsApi
     */
    queueRepairNfts(options) {
        return NftsApiFp(this.configuration).queueRepairNfts(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {NftsApiQueueRepairNftsAddressRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NftsApi
     */
    queueRepairNftsAddress(requestParameters, options) {
        return NftsApiFp(this.configuration).queueRepairNftsAddress(requestParameters.address, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NftsApi
     */
    repeatableJob(options) {
        return NftsApiFp(this.configuration).repeatableJob(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {NftsApiRepeatableJobKeyRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NftsApi
     */
    repeatableJobKey(requestParameters, options) {
        return NftsApiFp(this.configuration).repeatableJobKey(requestParameters.key, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {NftsApiUpdateNftRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NftsApi
     */
    updateNft(requestParameters, options) {
        return NftsApiFp(this.configuration).updateNft(requestParameters.contractAddress, requestParameters.id, requestParameters.nftUpdateData, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {NftsApiVerifySignedMessageRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NftsApi
     */
    verifySignedMessage(requestParameters, options) {
        return NftsApiFp(this.configuration).verifySignedMessage(requestParameters.address, requestParameters.hashedMessage, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * OrdersApi - axios parameter creator
 * @export
 */
export const OrdersApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {string} network
         * @param {OrderCreateData} orderCreateData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createOrder: async (network, orderCreateData, options = {}) => {
            // verify required parameter 'network' is not null or undefined
            assertParamExists('createOrder', 'network', network);
            // verify required parameter 'orderCreateData' is not null or undefined
            assertParamExists('createOrder', 'orderCreateData', orderCreateData);
            const localVarPath = `/orders`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (network !== undefined) {
                localVarQueryParameter['network'] = network;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(orderCreateData, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} orderId
         * @param {string} network
         * @param {string} [transactionHash]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fulfillOrder: async (orderId, network, transactionHash, options = {}) => {
            // verify required parameter 'orderId' is not null or undefined
            assertParamExists('fulfillOrder', 'orderId', orderId);
            // verify required parameter 'network' is not null or undefined
            assertParamExists('fulfillOrder', 'network', network);
            const localVarPath = `/orders/{orderId}/fulfill`
                .replace(`{${"orderId"}}`, encodeURIComponent(String(orderId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (network !== undefined) {
                localVarQueryParameter['network'] = network;
            }
            if (transactionHash !== undefined) {
                localVarQueryParameter['transactionHash'] = transactionHash;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} nftContractAddress
         * @param {string} nftId
         * @param {number} [limit]
         * @param {number} [offset]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listOrders: async (nftContractAddress, nftId, limit, offset, options = {}) => {
            // verify required parameter 'nftContractAddress' is not null or undefined
            assertParamExists('listOrders', 'nftContractAddress', nftContractAddress);
            // verify required parameter 'nftId' is not null or undefined
            assertParamExists('listOrders', 'nftId', nftId);
            const localVarPath = `/orders/{nftContractAddress}/{nftId}`
                .replace(`{${"nftContractAddress"}}`, encodeURIComponent(String(nftContractAddress)))
                .replace(`{${"nftId"}}`, encodeURIComponent(String(nftId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} ownerAddress
         * @param {number} [limit]
         * @param {number} [offset]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        receiveOrdersByOwner: async (ownerAddress, limit, offset, options = {}) => {
            // verify required parameter 'ownerAddress' is not null or undefined
            assertParamExists('receiveOrdersByOwner', 'ownerAddress', ownerAddress);
            const localVarPath = `/orders/owner/{ownerAddress}`
                .replace(`{${"ownerAddress"}}`, encodeURIComponent(String(ownerAddress)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * OrdersApi - functional programming interface
 * @export
 */
export const OrdersApiFp = function (configuration) {
    const localVarAxiosParamCreator = OrdersApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @param {string} network
         * @param {OrderCreateData} orderCreateData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createOrder(network, orderCreateData, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createOrder(network, orderCreateData, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {number} orderId
         * @param {string} network
         * @param {string} [transactionHash]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async fulfillOrder(orderId, network, transactionHash, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.fulfillOrder(orderId, network, transactionHash, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {string} nftContractAddress
         * @param {string} nftId
         * @param {number} [limit]
         * @param {number} [offset]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listOrders(nftContractAddress, nftId, limit, offset, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listOrders(nftContractAddress, nftId, limit, offset, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {string} ownerAddress
         * @param {number} [limit]
         * @param {number} [offset]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async receiveOrdersByOwner(ownerAddress, limit, offset, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.receiveOrdersByOwner(ownerAddress, limit, offset, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    };
};
/**
 * OrdersApi - factory interface
 * @export
 */
export const OrdersApiFactory = function (configuration, basePath, axios) {
    const localVarFp = OrdersApiFp(configuration);
    return {
        /**
         *
         * @param {string} network
         * @param {OrderCreateData} orderCreateData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createOrder(network, orderCreateData, options) {
            return localVarFp.createOrder(network, orderCreateData, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} orderId
         * @param {string} network
         * @param {string} [transactionHash]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fulfillOrder(orderId, network, transactionHash, options) {
            return localVarFp.fulfillOrder(orderId, network, transactionHash, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} nftContractAddress
         * @param {string} nftId
         * @param {number} [limit]
         * @param {number} [offset]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listOrders(nftContractAddress, nftId, limit, offset, options) {
            return localVarFp.listOrders(nftContractAddress, nftId, limit, offset, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} ownerAddress
         * @param {number} [limit]
         * @param {number} [offset]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        receiveOrdersByOwner(ownerAddress, limit, offset, options) {
            return localVarFp.receiveOrdersByOwner(ownerAddress, limit, offset, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * OrdersApi - object-oriented interface
 * @export
 * @class OrdersApi
 * @extends {BaseAPI}
 */
export class OrdersApi extends BaseAPI {
    /**
     *
     * @param {OrdersApiCreateOrderRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrdersApi
     */
    createOrder(requestParameters, options) {
        return OrdersApiFp(this.configuration).createOrder(requestParameters.network, requestParameters.orderCreateData, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {OrdersApiFulfillOrderRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrdersApi
     */
    fulfillOrder(requestParameters, options) {
        return OrdersApiFp(this.configuration).fulfillOrder(requestParameters.orderId, requestParameters.network, requestParameters.transactionHash, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {OrdersApiListOrdersRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrdersApi
     */
    listOrders(requestParameters, options) {
        return OrdersApiFp(this.configuration).listOrders(requestParameters.nftContractAddress, requestParameters.nftId, requestParameters.limit, requestParameters.offset, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {OrdersApiReceiveOrdersByOwnerRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrdersApi
     */
    receiveOrdersByOwner(requestParameters, options) {
        return OrdersApiFp(this.configuration).receiveOrdersByOwner(requestParameters.ownerAddress, requestParameters.limit, requestParameters.offset, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * ProjectsApi - axios parameter creator
 * @export
 */
export const ProjectsApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {FileCreateData} fileCreateData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createFileUpload: async (fileCreateData, options = {}) => {
            // verify required parameter 'fileCreateData' is not null or undefined
            assertParamExists('createFileUpload', 'fileCreateData', fileCreateData);
            const localVarPath = `/projects/project-create-file-upload`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication AccessToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(fileCreateData, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {ProjectCreateData} projectCreateData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createProject: async (projectCreateData, options = {}) => {
            // verify required parameter 'projectCreateData' is not null or undefined
            assertParamExists('createProject', 'projectCreateData', projectCreateData);
            const localVarPath = `/projects`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication AccessToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(projectCreateData, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {ProjectSubmissionFormBody} projectSubmissionFormBody
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createSubmissionFormRecord: async (projectSubmissionFormBody, options = {}) => {
            // verify required parameter 'projectSubmissionFormBody' is not null or undefined
            assertParamExists('createSubmissionFormRecord', 'projectSubmissionFormBody', projectSubmissionFormBody);
            const localVarPath = `/projects/form`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(projectSubmissionFormBody, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} id
         * @param {Array<ProjectInclude>} [include]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProject: async (id, include, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getProject', 'id', id);
            const localVarPath = `/projects/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (include) {
                localVarQueryParameter['include'] = include;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        indexAllProjects: async (options = {}) => {
            const localVarPath = `/projects/indexAllProjects`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication AccessToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} [limit]
         * @param {number} [offset]
         * @param {ProjectSort} [sort]
         * @param {Array<ProjectStatus>} [status]
         * @param {Array<ProjectProductionStatus>} [productionStatus]
         * @param {ProjectFilter} [filter]
         * @param {boolean} [indexed]
         * @param {Array<ProjectListInclude>} [include]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listProjects: async (limit, offset, sort, status, productionStatus, filter, indexed, include, options = {}) => {
            const localVarPath = `/projects`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication AccessToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }
            if (sort !== undefined) {
                localVarQueryParameter['sort'] = sort;
            }
            if (status) {
                localVarQueryParameter['status'] = status;
            }
            if (productionStatus) {
                localVarQueryParameter['productionStatus'] = productionStatus;
            }
            if (filter !== undefined) {
                localVarQueryParameter['filter'] = filter;
            }
            if (indexed !== undefined) {
                localVarQueryParameter['indexed'] = indexed;
            }
            if (include) {
                localVarQueryParameter['include'] = include;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} [limit]
         * @param {number} [offset]
         * @param {ProjectSort} [sort]
         * @param {Array<ProjectProductionStatus>} [productionStatus]
         * @param {ProjectFilter} [filter]
         * @param {Array<ProjectListInclude>} [include]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listProjectsPublic: async (limit, offset, sort, productionStatus, filter, include, options = {}) => {
            const localVarPath = `/projects/public`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }
            if (sort !== undefined) {
                localVarQueryParameter['sort'] = sort;
            }
            if (productionStatus) {
                localVarQueryParameter['productionStatus'] = productionStatus;
            }
            if (filter !== undefined) {
                localVarQueryParameter['filter'] = filter;
            }
            if (include) {
                localVarQueryParameter['include'] = include;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} id
         * @param {ProjectUpdateData} projectUpdateData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateProject: async (id, projectUpdateData, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateProject', 'id', id);
            // verify required parameter 'projectUpdateData' is not null or undefined
            assertParamExists('updateProject', 'projectUpdateData', projectUpdateData);
            const localVarPath = `/projects/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication AccessToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(projectUpdateData, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * ProjectsApi - functional programming interface
 * @export
 */
export const ProjectsApiFp = function (configuration) {
    const localVarAxiosParamCreator = ProjectsApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @param {FileCreateData} fileCreateData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createFileUpload(fileCreateData, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createFileUpload(fileCreateData, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {ProjectCreateData} projectCreateData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createProject(projectCreateData, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createProject(projectCreateData, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {ProjectSubmissionFormBody} projectSubmissionFormBody
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createSubmissionFormRecord(projectSubmissionFormBody, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createSubmissionFormRecord(projectSubmissionFormBody, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {string} id
         * @param {Array<ProjectInclude>} [include]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getProject(id, include, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getProject(id, include, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async indexAllProjects(options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.indexAllProjects(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {number} [limit]
         * @param {number} [offset]
         * @param {ProjectSort} [sort]
         * @param {Array<ProjectStatus>} [status]
         * @param {Array<ProjectProductionStatus>} [productionStatus]
         * @param {ProjectFilter} [filter]
         * @param {boolean} [indexed]
         * @param {Array<ProjectListInclude>} [include]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listProjects(limit, offset, sort, status, productionStatus, filter, indexed, include, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listProjects(limit, offset, sort, status, productionStatus, filter, indexed, include, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {number} [limit]
         * @param {number} [offset]
         * @param {ProjectSort} [sort]
         * @param {Array<ProjectProductionStatus>} [productionStatus]
         * @param {ProjectFilter} [filter]
         * @param {Array<ProjectListInclude>} [include]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listProjectsPublic(limit, offset, sort, productionStatus, filter, include, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listProjectsPublic(limit, offset, sort, productionStatus, filter, include, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {string} id
         * @param {ProjectUpdateData} projectUpdateData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateProject(id, projectUpdateData, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateProject(id, projectUpdateData, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    };
};
/**
 * ProjectsApi - factory interface
 * @export
 */
export const ProjectsApiFactory = function (configuration, basePath, axios) {
    const localVarFp = ProjectsApiFp(configuration);
    return {
        /**
         *
         * @param {FileCreateData} fileCreateData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createFileUpload(fileCreateData, options) {
            return localVarFp.createFileUpload(fileCreateData, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {ProjectCreateData} projectCreateData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createProject(projectCreateData, options) {
            return localVarFp.createProject(projectCreateData, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {ProjectSubmissionFormBody} projectSubmissionFormBody
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createSubmissionFormRecord(projectSubmissionFormBody, options) {
            return localVarFp.createSubmissionFormRecord(projectSubmissionFormBody, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} id
         * @param {Array<ProjectInclude>} [include]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProject(id, include, options) {
            return localVarFp.getProject(id, include, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        indexAllProjects(options) {
            return localVarFp.indexAllProjects(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} [limit]
         * @param {number} [offset]
         * @param {ProjectSort} [sort]
         * @param {Array<ProjectStatus>} [status]
         * @param {Array<ProjectProductionStatus>} [productionStatus]
         * @param {ProjectFilter} [filter]
         * @param {boolean} [indexed]
         * @param {Array<ProjectListInclude>} [include]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listProjects(limit, offset, sort, status, productionStatus, filter, indexed, include, options) {
            return localVarFp.listProjects(limit, offset, sort, status, productionStatus, filter, indexed, include, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} [limit]
         * @param {number} [offset]
         * @param {ProjectSort} [sort]
         * @param {Array<ProjectProductionStatus>} [productionStatus]
         * @param {ProjectFilter} [filter]
         * @param {Array<ProjectListInclude>} [include]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listProjectsPublic(limit, offset, sort, productionStatus, filter, include, options) {
            return localVarFp.listProjectsPublic(limit, offset, sort, productionStatus, filter, include, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} id
         * @param {ProjectUpdateData} projectUpdateData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateProject(id, projectUpdateData, options) {
            return localVarFp.updateProject(id, projectUpdateData, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * ProjectsApi - object-oriented interface
 * @export
 * @class ProjectsApi
 * @extends {BaseAPI}
 */
export class ProjectsApi extends BaseAPI {
    /**
     *
     * @param {ProjectsApiCreateFileUploadRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProjectsApi
     */
    createFileUpload(requestParameters, options) {
        return ProjectsApiFp(this.configuration).createFileUpload(requestParameters.fileCreateData, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {ProjectsApiCreateProjectRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProjectsApi
     */
    createProject(requestParameters, options) {
        return ProjectsApiFp(this.configuration).createProject(requestParameters.projectCreateData, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {ProjectsApiCreateSubmissionFormRecordRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProjectsApi
     */
    createSubmissionFormRecord(requestParameters, options) {
        return ProjectsApiFp(this.configuration).createSubmissionFormRecord(requestParameters.projectSubmissionFormBody, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {ProjectsApiGetProjectRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProjectsApi
     */
    getProject(requestParameters, options) {
        return ProjectsApiFp(this.configuration).getProject(requestParameters.id, requestParameters.include, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProjectsApi
     */
    indexAllProjects(options) {
        return ProjectsApiFp(this.configuration).indexAllProjects(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {ProjectsApiListProjectsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProjectsApi
     */
    listProjects(requestParameters = {}, options) {
        return ProjectsApiFp(this.configuration).listProjects(requestParameters.limit, requestParameters.offset, requestParameters.sort, requestParameters.status, requestParameters.productionStatus, requestParameters.filter, requestParameters.indexed, requestParameters.include, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {ProjectsApiListProjectsPublicRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProjectsApi
     */
    listProjectsPublic(requestParameters = {}, options) {
        return ProjectsApiFp(this.configuration).listProjectsPublic(requestParameters.limit, requestParameters.offset, requestParameters.sort, requestParameters.productionStatus, requestParameters.filter, requestParameters.include, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {ProjectsApiUpdateProjectRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProjectsApi
     */
    updateProject(requestParameters, options) {
        return ProjectsApiFp(this.configuration).updateProject(requestParameters.id, requestParameters.projectUpdateData, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * RoadmapApi - axios parameter creator
 * @export
 */
export const RoadmapApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {RoadmapCreateData} roadmapCreateData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createRoadmap: async (roadmapCreateData, options = {}) => {
            // verify required parameter 'roadmapCreateData' is not null or undefined
            assertParamExists('createRoadmap', 'roadmapCreateData', roadmapCreateData);
            const localVarPath = `/roadmap`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication AccessToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(roadmapCreateData, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteRoadmap: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteRoadmap', 'id', id);
            const localVarPath = `/roadmap/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication AccessToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRoadmap: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getRoadmap', 'id', id);
            const localVarPath = `/roadmap/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} id
         * @param {RoadmapUpdateData} roadmapUpdateData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateRoadmap: async (id, roadmapUpdateData, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateRoadmap', 'id', id);
            // verify required parameter 'roadmapUpdateData' is not null or undefined
            assertParamExists('updateRoadmap', 'roadmapUpdateData', roadmapUpdateData);
            const localVarPath = `/roadmap/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication AccessToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(roadmapUpdateData, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * RoadmapApi - functional programming interface
 * @export
 */
export const RoadmapApiFp = function (configuration) {
    const localVarAxiosParamCreator = RoadmapApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @param {RoadmapCreateData} roadmapCreateData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createRoadmap(roadmapCreateData, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createRoadmap(roadmapCreateData, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteRoadmap(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteRoadmap(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getRoadmap(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getRoadmap(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {string} id
         * @param {RoadmapUpdateData} roadmapUpdateData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateRoadmap(id, roadmapUpdateData, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateRoadmap(id, roadmapUpdateData, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    };
};
/**
 * RoadmapApi - factory interface
 * @export
 */
export const RoadmapApiFactory = function (configuration, basePath, axios) {
    const localVarFp = RoadmapApiFp(configuration);
    return {
        /**
         *
         * @param {RoadmapCreateData} roadmapCreateData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createRoadmap(roadmapCreateData, options) {
            return localVarFp.createRoadmap(roadmapCreateData, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteRoadmap(id, options) {
            return localVarFp.deleteRoadmap(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRoadmap(id, options) {
            return localVarFp.getRoadmap(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} id
         * @param {RoadmapUpdateData} roadmapUpdateData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateRoadmap(id, roadmapUpdateData, options) {
            return localVarFp.updateRoadmap(id, roadmapUpdateData, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * RoadmapApi - object-oriented interface
 * @export
 * @class RoadmapApi
 * @extends {BaseAPI}
 */
export class RoadmapApi extends BaseAPI {
    /**
     *
     * @param {RoadmapApiCreateRoadmapRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RoadmapApi
     */
    createRoadmap(requestParameters, options) {
        return RoadmapApiFp(this.configuration).createRoadmap(requestParameters.roadmapCreateData, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {RoadmapApiDeleteRoadmapRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RoadmapApi
     */
    deleteRoadmap(requestParameters, options) {
        return RoadmapApiFp(this.configuration).deleteRoadmap(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {RoadmapApiGetRoadmapRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RoadmapApi
     */
    getRoadmap(requestParameters, options) {
        return RoadmapApiFp(this.configuration).getRoadmap(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {RoadmapApiUpdateRoadmapRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RoadmapApi
     */
    updateRoadmap(requestParameters, options) {
        return RoadmapApiFp(this.configuration).updateRoadmap(requestParameters.id, requestParameters.roadmapUpdateData, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * SearchApi - axios parameter creator
 * @export
 */
export const SearchApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {string} text
         * @param {Array<EntityTypeName>} [type]
         * @param {number} [limit]
         * @param {number} [offset]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        search: async (text, type, limit, offset, options = {}) => {
            // verify required parameter 'text' is not null or undefined
            assertParamExists('search', 'text', text);
            const localVarPath = `/search`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication AccessToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (text !== undefined) {
                localVarQueryParameter['text'] = text;
            }
            if (type) {
                localVarQueryParameter['type'] = type;
            }
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} text
         * @param {Array<EntityTypeName>} [type]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        suggest: async (text, type, options = {}) => {
            // verify required parameter 'text' is not null or undefined
            assertParamExists('suggest', 'text', text);
            const localVarPath = `/suggest`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication AccessToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (text !== undefined) {
                localVarQueryParameter['text'] = text;
            }
            if (type) {
                localVarQueryParameter['type'] = type;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * SearchApi - functional programming interface
 * @export
 */
export const SearchApiFp = function (configuration) {
    const localVarAxiosParamCreator = SearchApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @param {string} text
         * @param {Array<EntityTypeName>} [type]
         * @param {number} [limit]
         * @param {number} [offset]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async search(text, type, limit, offset, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.search(text, type, limit, offset, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {string} text
         * @param {Array<EntityTypeName>} [type]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async suggest(text, type, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.suggest(text, type, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    };
};
/**
 * SearchApi - factory interface
 * @export
 */
export const SearchApiFactory = function (configuration, basePath, axios) {
    const localVarFp = SearchApiFp(configuration);
    return {
        /**
         *
         * @param {string} text
         * @param {Array<EntityTypeName>} [type]
         * @param {number} [limit]
         * @param {number} [offset]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        search(text, type, limit, offset, options) {
            return localVarFp.search(text, type, limit, offset, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} text
         * @param {Array<EntityTypeName>} [type]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        suggest(text, type, options) {
            return localVarFp.suggest(text, type, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * SearchApi - object-oriented interface
 * @export
 * @class SearchApi
 * @extends {BaseAPI}
 */
export class SearchApi extends BaseAPI {
    /**
     *
     * @param {SearchApiSearchRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SearchApi
     */
    search(requestParameters, options) {
        return SearchApiFp(this.configuration).search(requestParameters.text, requestParameters.type, requestParameters.limit, requestParameters.offset, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {SearchApiSuggestRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SearchApi
     */
    suggest(requestParameters, options) {
        return SearchApiFp(this.configuration).suggest(requestParameters.text, requestParameters.type, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * TransactionsApi - axios parameter creator
 * @export
 */
export const TransactionsApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {string} network
         * @param {string} hash
         * @param {TransactionType} transactionType
         * @param {number} listingId
         * @param {string} [email]
         * @param {string} [hashedMessage]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createTransaction: async (network, hash, transactionType, listingId, email, hashedMessage, options = {}) => {
            // verify required parameter 'network' is not null or undefined
            assertParamExists('createTransaction', 'network', network);
            // verify required parameter 'hash' is not null or undefined
            assertParamExists('createTransaction', 'hash', hash);
            // verify required parameter 'transactionType' is not null or undefined
            assertParamExists('createTransaction', 'transactionType', transactionType);
            // verify required parameter 'listingId' is not null or undefined
            assertParamExists('createTransaction', 'listingId', listingId);
            const localVarPath = `/transactions/create/{network}/{hash}/{transactionType}/{listingId}`
                .replace(`{${"network"}}`, encodeURIComponent(String(network)))
                .replace(`{${"hash"}}`, encodeURIComponent(String(hash)))
                .replace(`{${"transactionType"}}`, encodeURIComponent(String(transactionType)))
                .replace(`{${"listingId"}}`, encodeURIComponent(String(listingId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (email !== undefined) {
                localVarQueryParameter['email'] = email;
            }
            if (hashedMessage !== undefined) {
                localVarQueryParameter['hashedMessage'] = hashedMessage;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} walletAddress
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        notifsEnabled: async (walletAddress, options = {}) => {
            // verify required parameter 'walletAddress' is not null or undefined
            assertParamExists('notifsEnabled', 'walletAddress', walletAddress);
            const localVarPath = `/transactions/notifs/{walletAddress}`
                .replace(`{${"walletAddress"}}`, encodeURIComponent(String(walletAddress)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * TransactionsApi - functional programming interface
 * @export
 */
export const TransactionsApiFp = function (configuration) {
    const localVarAxiosParamCreator = TransactionsApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @param {string} network
         * @param {string} hash
         * @param {TransactionType} transactionType
         * @param {number} listingId
         * @param {string} [email]
         * @param {string} [hashedMessage]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createTransaction(network, hash, transactionType, listingId, email, hashedMessage, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createTransaction(network, hash, transactionType, listingId, email, hashedMessage, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {string} walletAddress
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async notifsEnabled(walletAddress, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.notifsEnabled(walletAddress, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    };
};
/**
 * TransactionsApi - factory interface
 * @export
 */
export const TransactionsApiFactory = function (configuration, basePath, axios) {
    const localVarFp = TransactionsApiFp(configuration);
    return {
        /**
         *
         * @param {string} network
         * @param {string} hash
         * @param {TransactionType} transactionType
         * @param {number} listingId
         * @param {string} [email]
         * @param {string} [hashedMessage]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createTransaction(network, hash, transactionType, listingId, email, hashedMessage, options) {
            return localVarFp.createTransaction(network, hash, transactionType, listingId, email, hashedMessage, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} walletAddress
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        notifsEnabled(walletAddress, options) {
            return localVarFp.notifsEnabled(walletAddress, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * TransactionsApi - object-oriented interface
 * @export
 * @class TransactionsApi
 * @extends {BaseAPI}
 */
export class TransactionsApi extends BaseAPI {
    /**
     *
     * @param {TransactionsApiCreateTransactionRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TransactionsApi
     */
    createTransaction(requestParameters, options) {
        return TransactionsApiFp(this.configuration).createTransaction(requestParameters.network, requestParameters.hash, requestParameters.transactionType, requestParameters.listingId, requestParameters.email, requestParameters.hashedMessage, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {TransactionsApiNotifsEnabledRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TransactionsApi
     */
    notifsEnabled(requestParameters, options) {
        return TransactionsApiFp(this.configuration).notifsEnabled(requestParameters.walletAddress, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * UpdatesApi - axios parameter creator
 * @export
 */
export const UpdatesApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {number} [limit]
         * @param {number} [offset]
         * @param {PostSort} [sort]
         * @param {Array<PostInclude>} [include]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listUpdates: async (limit, offset, sort, include, options = {}) => {
            const localVarPath = `/updates`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication AccessToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }
            if (sort !== undefined) {
                localVarQueryParameter['sort'] = sort;
            }
            if (include) {
                localVarQueryParameter['include'] = include;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * UpdatesApi - functional programming interface
 * @export
 */
export const UpdatesApiFp = function (configuration) {
    const localVarAxiosParamCreator = UpdatesApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @param {number} [limit]
         * @param {number} [offset]
         * @param {PostSort} [sort]
         * @param {Array<PostInclude>} [include]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listUpdates(limit, offset, sort, include, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listUpdates(limit, offset, sort, include, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    };
};
/**
 * UpdatesApi - factory interface
 * @export
 */
export const UpdatesApiFactory = function (configuration, basePath, axios) {
    const localVarFp = UpdatesApiFp(configuration);
    return {
        /**
         *
         * @param {number} [limit]
         * @param {number} [offset]
         * @param {PostSort} [sort]
         * @param {Array<PostInclude>} [include]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listUpdates(limit, offset, sort, include, options) {
            return localVarFp.listUpdates(limit, offset, sort, include, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * UpdatesApi - object-oriented interface
 * @export
 * @class UpdatesApi
 * @extends {BaseAPI}
 */
export class UpdatesApi extends BaseAPI {
    /**
     *
     * @param {UpdatesApiListUpdatesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UpdatesApi
     */
    listUpdates(requestParameters = {}, options) {
        return UpdatesApiFp(this.configuration).listUpdates(requestParameters.limit, requestParameters.offset, requestParameters.sort, requestParameters.include, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * UsersApi - axios parameter creator
 * @export
 */
export const UsersApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {UserCreateData} userCreateData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createUser: async (userCreateData, options = {}) => {
            // verify required parameter 'userCreateData' is not null or undefined
            assertParamExists('createUser', 'userCreateData', userCreateData);
            const localVarPath = `/users`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication AccessToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(userCreateData, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteUser: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteUser', 'id', id);
            const localVarPath = `/users/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication AccessToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        disableUserMfa: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('disableUserMfa', 'id', id);
            const localVarPath = `/users/{id}/mfa`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication AccessToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} id
         * @param {Array<UserInclude>} [include]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUser: async (id, include, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getUser', 'id', id);
            const localVarPath = `/users/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication AccessToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (include) {
                localVarQueryParameter['include'] = include;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        indexAll: async (options = {}) => {
            const localVarPath = `/users/index`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication AccessToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        indexUser: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('indexUser', 'id', id);
            const localVarPath = `/users/{id}/index`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication AccessToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} [limit]
         * @param {number} [offset]
         * @param {UserSort} [sort]
         * @param {Array<UserStatus>} [status]
         * @param {Array<PlatformRole>} [role]
         * @param {boolean} [indexed]
         * @param {Array<UserInclude>} [include]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listUsers: async (limit, offset, sort, status, role, indexed, include, options = {}) => {
            const localVarPath = `/users`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication AccessToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }
            if (sort !== undefined) {
                localVarQueryParameter['sort'] = sort;
            }
            if (status) {
                localVarQueryParameter['status'] = status;
            }
            if (role) {
                localVarQueryParameter['role'] = role;
            }
            if (indexed !== undefined) {
                localVarQueryParameter['indexed'] = indexed;
            }
            if (include) {
                localVarQueryParameter['include'] = include;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * UsersApi - functional programming interface
 * @export
 */
export const UsersApiFp = function (configuration) {
    const localVarAxiosParamCreator = UsersApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @param {UserCreateData} userCreateData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createUser(userCreateData, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createUser(userCreateData, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteUser(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteUser(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async disableUserMfa(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.disableUserMfa(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {string} id
         * @param {Array<UserInclude>} [include]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getUser(id, include, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getUser(id, include, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async indexAll(options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.indexAll(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async indexUser(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.indexUser(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {number} [limit]
         * @param {number} [offset]
         * @param {UserSort} [sort]
         * @param {Array<UserStatus>} [status]
         * @param {Array<PlatformRole>} [role]
         * @param {boolean} [indexed]
         * @param {Array<UserInclude>} [include]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listUsers(limit, offset, sort, status, role, indexed, include, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listUsers(limit, offset, sort, status, role, indexed, include, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    };
};
/**
 * UsersApi - factory interface
 * @export
 */
export const UsersApiFactory = function (configuration, basePath, axios) {
    const localVarFp = UsersApiFp(configuration);
    return {
        /**
         *
         * @param {UserCreateData} userCreateData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createUser(userCreateData, options) {
            return localVarFp.createUser(userCreateData, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteUser(id, options) {
            return localVarFp.deleteUser(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        disableUserMfa(id, options) {
            return localVarFp.disableUserMfa(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} id
         * @param {Array<UserInclude>} [include]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUser(id, include, options) {
            return localVarFp.getUser(id, include, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        indexAll(options) {
            return localVarFp.indexAll(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        indexUser(id, options) {
            return localVarFp.indexUser(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} [limit]
         * @param {number} [offset]
         * @param {UserSort} [sort]
         * @param {Array<UserStatus>} [status]
         * @param {Array<PlatformRole>} [role]
         * @param {boolean} [indexed]
         * @param {Array<UserInclude>} [include]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listUsers(limit, offset, sort, status, role, indexed, include, options) {
            return localVarFp.listUsers(limit, offset, sort, status, role, indexed, include, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * UsersApi - object-oriented interface
 * @export
 * @class UsersApi
 * @extends {BaseAPI}
 */
export class UsersApi extends BaseAPI {
    /**
     *
     * @param {UsersApiCreateUserRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    createUser(requestParameters, options) {
        return UsersApiFp(this.configuration).createUser(requestParameters.userCreateData, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {UsersApiDeleteUserRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    deleteUser(requestParameters, options) {
        return UsersApiFp(this.configuration).deleteUser(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {UsersApiDisableUserMfaRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    disableUserMfa(requestParameters, options) {
        return UsersApiFp(this.configuration).disableUserMfa(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {UsersApiGetUserRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    getUser(requestParameters, options) {
        return UsersApiFp(this.configuration).getUser(requestParameters.id, requestParameters.include, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    indexAll(options) {
        return UsersApiFp(this.configuration).indexAll(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {UsersApiIndexUserRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    indexUser(requestParameters, options) {
        return UsersApiFp(this.configuration).indexUser(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {UsersApiListUsersRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    listUsers(requestParameters = {}, options) {
        return UsersApiFp(this.configuration).listUsers(requestParameters.limit, requestParameters.offset, requestParameters.sort, requestParameters.status, requestParameters.role, requestParameters.indexed, requestParameters.include, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * ViewerApi - axios parameter creator
 * @export
 */
export const ViewerApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        disableMfa: async (options = {}) => {
            const localVarPath = `/viewer/mfa`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication AccessToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getViewer: async (options = {}) => {
            const localVarPath = `/viewer`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication AccessToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getViewerPreferences: async (options = {}) => {
            const localVarPath = `/viewer/preferences`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication AccessToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        initMfa: async (options = {}) => {
            const localVarPath = `/viewer/mfa`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication AccessToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {FileCreateData} fileCreateData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setProfileImage: async (fileCreateData, options = {}) => {
            // verify required parameter 'fileCreateData' is not null or undefined
            assertParamExists('setProfileImage', 'fileCreateData', fileCreateData);
            const localVarPath = `/viewer/image`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication AccessToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(fileCreateData, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {SetPasswordData} setPasswordData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setViewerPassword: async (setPasswordData, options = {}) => {
            // verify required parameter 'setPasswordData' is not null or undefined
            assertParamExists('setViewerPassword', 'setPasswordData', setPasswordData);
            const localVarPath = `/viewer/password`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Basic required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(setPasswordData, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {UserPreferencesUpdateData} userPreferencesUpdateData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        toggleEmailNotify: async (userPreferencesUpdateData, options = {}) => {
            // verify required parameter 'userPreferencesUpdateData' is not null or undefined
            assertParamExists('toggleEmailNotify', 'userPreferencesUpdateData', userPreferencesUpdateData);
            const localVarPath = `/viewer/profile/toggle-email-notify`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication AccessToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(userPreferencesUpdateData, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {UserPreferencesUpdateData} userPreferencesUpdateData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateViewerPreferences: async (userPreferencesUpdateData, options = {}) => {
            // verify required parameter 'userPreferencesUpdateData' is not null or undefined
            assertParamExists('updateViewerPreferences', 'userPreferencesUpdateData', userPreferencesUpdateData);
            const localVarPath = `/viewer/preferences`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication AccessToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(userPreferencesUpdateData, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {UserProfileUpdateData} userProfileUpdateData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateViewerProfile: async (userProfileUpdateData, options = {}) => {
            // verify required parameter 'userProfileUpdateData' is not null or undefined
            assertParamExists('updateViewerProfile', 'userProfileUpdateData', userProfileUpdateData);
            const localVarPath = `/viewer/profile`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication AccessToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(userProfileUpdateData, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * ViewerApi - functional programming interface
 * @export
 */
export const ViewerApiFp = function (configuration) {
    const localVarAxiosParamCreator = ViewerApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async disableMfa(options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.disableMfa(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getViewer(options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getViewer(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getViewerPreferences(options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getViewerPreferences(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async initMfa(options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.initMfa(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {FileCreateData} fileCreateData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async setProfileImage(fileCreateData, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.setProfileImage(fileCreateData, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {SetPasswordData} setPasswordData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async setViewerPassword(setPasswordData, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.setViewerPassword(setPasswordData, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {UserPreferencesUpdateData} userPreferencesUpdateData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async toggleEmailNotify(userPreferencesUpdateData, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.toggleEmailNotify(userPreferencesUpdateData, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {UserPreferencesUpdateData} userPreferencesUpdateData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateViewerPreferences(userPreferencesUpdateData, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateViewerPreferences(userPreferencesUpdateData, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {UserProfileUpdateData} userProfileUpdateData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateViewerProfile(userProfileUpdateData, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateViewerProfile(userProfileUpdateData, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    };
};
/**
 * ViewerApi - factory interface
 * @export
 */
export const ViewerApiFactory = function (configuration, basePath, axios) {
    const localVarFp = ViewerApiFp(configuration);
    return {
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        disableMfa(options) {
            return localVarFp.disableMfa(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getViewer(options) {
            return localVarFp.getViewer(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getViewerPreferences(options) {
            return localVarFp.getViewerPreferences(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        initMfa(options) {
            return localVarFp.initMfa(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {FileCreateData} fileCreateData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setProfileImage(fileCreateData, options) {
            return localVarFp.setProfileImage(fileCreateData, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {SetPasswordData} setPasswordData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setViewerPassword(setPasswordData, options) {
            return localVarFp.setViewerPassword(setPasswordData, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {UserPreferencesUpdateData} userPreferencesUpdateData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        toggleEmailNotify(userPreferencesUpdateData, options) {
            return localVarFp.toggleEmailNotify(userPreferencesUpdateData, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {UserPreferencesUpdateData} userPreferencesUpdateData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateViewerPreferences(userPreferencesUpdateData, options) {
            return localVarFp.updateViewerPreferences(userPreferencesUpdateData, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {UserProfileUpdateData} userProfileUpdateData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateViewerProfile(userProfileUpdateData, options) {
            return localVarFp.updateViewerProfile(userProfileUpdateData, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * ViewerApi - object-oriented interface
 * @export
 * @class ViewerApi
 * @extends {BaseAPI}
 */
export class ViewerApi extends BaseAPI {
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ViewerApi
     */
    disableMfa(options) {
        return ViewerApiFp(this.configuration).disableMfa(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ViewerApi
     */
    getViewer(options) {
        return ViewerApiFp(this.configuration).getViewer(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ViewerApi
     */
    getViewerPreferences(options) {
        return ViewerApiFp(this.configuration).getViewerPreferences(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ViewerApi
     */
    initMfa(options) {
        return ViewerApiFp(this.configuration).initMfa(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {ViewerApiSetProfileImageRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ViewerApi
     */
    setProfileImage(requestParameters, options) {
        return ViewerApiFp(this.configuration).setProfileImage(requestParameters.fileCreateData, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {ViewerApiSetViewerPasswordRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ViewerApi
     */
    setViewerPassword(requestParameters, options) {
        return ViewerApiFp(this.configuration).setViewerPassword(requestParameters.setPasswordData, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {ViewerApiToggleEmailNotifyRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ViewerApi
     */
    toggleEmailNotify(requestParameters, options) {
        return ViewerApiFp(this.configuration).toggleEmailNotify(requestParameters.userPreferencesUpdateData, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {ViewerApiUpdateViewerPreferencesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ViewerApi
     */
    updateViewerPreferences(requestParameters, options) {
        return ViewerApiFp(this.configuration).updateViewerPreferences(requestParameters.userPreferencesUpdateData, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {ViewerApiUpdateViewerProfileRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ViewerApi
     */
    updateViewerProfile(requestParameters, options) {
        return ViewerApiFp(this.configuration).updateViewerProfile(requestParameters.userProfileUpdateData, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * WalletApi - axios parameter creator
 * @export
 */
export const WalletApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {string} address
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checkIfLinked: async (address, options = {}) => {
            // verify required parameter 'address' is not null or undefined
            assertParamExists('checkIfLinked', 'address', address);
            const localVarPath = `/wallet/{address}`
                .replace(`{${"address"}}`, encodeURIComponent(String(address)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication AccessToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} address
         * @param {string} signedHash
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        connectWalletAndLinkUser: async (address, signedHash, options = {}) => {
            // verify required parameter 'address' is not null or undefined
            assertParamExists('connectWalletAndLinkUser', 'address', address);
            // verify required parameter 'signedHash' is not null or undefined
            assertParamExists('connectWalletAndLinkUser', 'signedHash', signedHash);
            const localVarPath = `/wallet/connectAndLink/{address}/{signedHash}`
                .replace(`{${"address"}}`, encodeURIComponent(String(address)))
                .replace(`{${"signedHash"}}`, encodeURIComponent(String(signedHash)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication AccessToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {WalletCreateData} walletCreateData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createWallet: async (walletCreateData, options = {}) => {
            // verify required parameter 'walletCreateData' is not null or undefined
            assertParamExists('createWallet', 'walletCreateData', walletCreateData);
            const localVarPath = `/wallet`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication AccessToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(walletCreateData, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteWalletById: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteWalletById', 'id', id);
            const localVarPath = `/wallet/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication AccessToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} address
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOnlyWalletByAddress: async (address, options = {}) => {
            // verify required parameter 'address' is not null or undefined
            assertParamExists('getOnlyWalletByAddress', 'address', address);
            const localVarPath = `/wallet/getByAddress/{address}`
                .replace(`{${"address"}}`, encodeURIComponent(String(address)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWalletById: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getWalletById', 'id', id);
            const localVarPath = `/wallet/getById/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} userId
         * @param {string} address
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeWalletUserLink: async (userId, address, options = {}) => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('removeWalletUserLink', 'userId', userId);
            // verify required parameter 'address' is not null or undefined
            assertParamExists('removeWalletUserLink', 'address', address);
            const localVarPath = `/wallet/{userId}/{address}`
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)))
                .replace(`{${"address"}}`, encodeURIComponent(String(address)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication AccessToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} id
         * @param {WalletUpdateData} walletUpdateData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateWalletById: async (id, walletUpdateData, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateWalletById', 'id', id);
            // verify required parameter 'walletUpdateData' is not null or undefined
            assertParamExists('updateWalletById', 'walletUpdateData', walletUpdateData);
            const localVarPath = `/wallet/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication AccessToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(walletUpdateData, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * WalletApi - functional programming interface
 * @export
 */
export const WalletApiFp = function (configuration) {
    const localVarAxiosParamCreator = WalletApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @param {string} address
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async checkIfLinked(address, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.checkIfLinked(address, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {string} address
         * @param {string} signedHash
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async connectWalletAndLinkUser(address, signedHash, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.connectWalletAndLinkUser(address, signedHash, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {WalletCreateData} walletCreateData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createWallet(walletCreateData, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createWallet(walletCreateData, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteWalletById(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteWalletById(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {string} address
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getOnlyWalletByAddress(address, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getOnlyWalletByAddress(address, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getWalletById(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getWalletById(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {string} userId
         * @param {string} address
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async removeWalletUserLink(userId, address, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.removeWalletUserLink(userId, address, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {string} id
         * @param {WalletUpdateData} walletUpdateData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateWalletById(id, walletUpdateData, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateWalletById(id, walletUpdateData, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    };
};
/**
 * WalletApi - factory interface
 * @export
 */
export const WalletApiFactory = function (configuration, basePath, axios) {
    const localVarFp = WalletApiFp(configuration);
    return {
        /**
         *
         * @param {string} address
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checkIfLinked(address, options) {
            return localVarFp.checkIfLinked(address, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} address
         * @param {string} signedHash
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        connectWalletAndLinkUser(address, signedHash, options) {
            return localVarFp.connectWalletAndLinkUser(address, signedHash, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {WalletCreateData} walletCreateData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createWallet(walletCreateData, options) {
            return localVarFp.createWallet(walletCreateData, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteWalletById(id, options) {
            return localVarFp.deleteWalletById(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} address
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOnlyWalletByAddress(address, options) {
            return localVarFp.getOnlyWalletByAddress(address, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWalletById(id, options) {
            return localVarFp.getWalletById(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} userId
         * @param {string} address
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeWalletUserLink(userId, address, options) {
            return localVarFp.removeWalletUserLink(userId, address, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} id
         * @param {WalletUpdateData} walletUpdateData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateWalletById(id, walletUpdateData, options) {
            return localVarFp.updateWalletById(id, walletUpdateData, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * WalletApi - object-oriented interface
 * @export
 * @class WalletApi
 * @extends {BaseAPI}
 */
export class WalletApi extends BaseAPI {
    /**
     *
     * @param {WalletApiCheckIfLinkedRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WalletApi
     */
    checkIfLinked(requestParameters, options) {
        return WalletApiFp(this.configuration).checkIfLinked(requestParameters.address, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {WalletApiConnectWalletAndLinkUserRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WalletApi
     */
    connectWalletAndLinkUser(requestParameters, options) {
        return WalletApiFp(this.configuration).connectWalletAndLinkUser(requestParameters.address, requestParameters.signedHash, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {WalletApiCreateWalletRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WalletApi
     */
    createWallet(requestParameters, options) {
        return WalletApiFp(this.configuration).createWallet(requestParameters.walletCreateData, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {WalletApiDeleteWalletByIdRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WalletApi
     */
    deleteWalletById(requestParameters, options) {
        return WalletApiFp(this.configuration).deleteWalletById(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {WalletApiGetOnlyWalletByAddressRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WalletApi
     */
    getOnlyWalletByAddress(requestParameters, options) {
        return WalletApiFp(this.configuration).getOnlyWalletByAddress(requestParameters.address, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {WalletApiGetWalletByIdRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WalletApi
     */
    getWalletById(requestParameters, options) {
        return WalletApiFp(this.configuration).getWalletById(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {WalletApiRemoveWalletUserLinkRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WalletApi
     */
    removeWalletUserLink(requestParameters, options) {
        return WalletApiFp(this.configuration).removeWalletUserLink(requestParameters.userId, requestParameters.address, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {WalletApiUpdateWalletByIdRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WalletApi
     */
    updateWalletById(requestParameters, options) {
        return WalletApiFp(this.configuration).updateWalletById(requestParameters.id, requestParameters.walletUpdateData, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * WhitelistApi - axios parameter creator
 * @export
 */
export const WhitelistApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {WhitelistCreateData} whitelistCreateData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createWhitelist: async (whitelistCreateData, options = {}) => {
            // verify required parameter 'whitelistCreateData' is not null or undefined
            assertParamExists('createWhitelist', 'whitelistCreateData', whitelistCreateData);
            const localVarPath = `/whitelist`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication AccessToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(whitelistCreateData, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteWhitelist: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteWhitelist', 'id', id);
            const localVarPath = `/whitelist/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication AccessToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        get: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('get', 'id', id);
            const localVarPath = `/whitelist/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication AccessToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} contractAddress
         * @param {string} walletAddress
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getByWalletAndCollection: async (contractAddress, walletAddress, options = {}) => {
            // verify required parameter 'contractAddress' is not null or undefined
            assertParamExists('getByWalletAndCollection', 'contractAddress', contractAddress);
            // verify required parameter 'walletAddress' is not null or undefined
            assertParamExists('getByWalletAndCollection', 'walletAddress', walletAddress);
            const localVarPath = `/whitelist/getByWalletAndCollection/{contractAddress}/{walletAddress}`
                .replace(`{${"contractAddress"}}`, encodeURIComponent(String(contractAddress)))
                .replace(`{${"walletAddress"}}`, encodeURIComponent(String(walletAddress)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} [limit]
         * @param {number} [offset]
         * @param {WhitelistSort} [sort]
         * @param {string} [collectionId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        list: async (limit, offset, sort, collectionId, options = {}) => {
            const localVarPath = `/whitelist`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication AccessToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }
            if (sort !== undefined) {
                localVarQueryParameter['sort'] = sort;
            }
            if (collectionId !== undefined) {
                localVarQueryParameter['collectionId'] = collectionId;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} id
         * @param {WhitelistUpdateData} whitelistUpdateData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateWhitelist: async (id, whitelistUpdateData, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateWhitelist', 'id', id);
            // verify required parameter 'whitelistUpdateData' is not null or undefined
            assertParamExists('updateWhitelist', 'whitelistUpdateData', whitelistUpdateData);
            const localVarPath = `/whitelist/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication AccessToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(whitelistUpdateData, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * WhitelistApi - functional programming interface
 * @export
 */
export const WhitelistApiFp = function (configuration) {
    const localVarAxiosParamCreator = WhitelistApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @param {WhitelistCreateData} whitelistCreateData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createWhitelist(whitelistCreateData, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createWhitelist(whitelistCreateData, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteWhitelist(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteWhitelist(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async get(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.get(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {string} contractAddress
         * @param {string} walletAddress
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getByWalletAndCollection(contractAddress, walletAddress, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getByWalletAndCollection(contractAddress, walletAddress, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {number} [limit]
         * @param {number} [offset]
         * @param {WhitelistSort} [sort]
         * @param {string} [collectionId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async list(limit, offset, sort, collectionId, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.list(limit, offset, sort, collectionId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {string} id
         * @param {WhitelistUpdateData} whitelistUpdateData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateWhitelist(id, whitelistUpdateData, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateWhitelist(id, whitelistUpdateData, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    };
};
/**
 * WhitelistApi - factory interface
 * @export
 */
export const WhitelistApiFactory = function (configuration, basePath, axios) {
    const localVarFp = WhitelistApiFp(configuration);
    return {
        /**
         *
         * @param {WhitelistCreateData} whitelistCreateData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createWhitelist(whitelistCreateData, options) {
            return localVarFp.createWhitelist(whitelistCreateData, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteWhitelist(id, options) {
            return localVarFp.deleteWhitelist(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        get(id, options) {
            return localVarFp.get(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} contractAddress
         * @param {string} walletAddress
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getByWalletAndCollection(contractAddress, walletAddress, options) {
            return localVarFp.getByWalletAndCollection(contractAddress, walletAddress, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} [limit]
         * @param {number} [offset]
         * @param {WhitelistSort} [sort]
         * @param {string} [collectionId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        list(limit, offset, sort, collectionId, options) {
            return localVarFp.list(limit, offset, sort, collectionId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} id
         * @param {WhitelistUpdateData} whitelistUpdateData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateWhitelist(id, whitelistUpdateData, options) {
            return localVarFp.updateWhitelist(id, whitelistUpdateData, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * WhitelistApi - object-oriented interface
 * @export
 * @class WhitelistApi
 * @extends {BaseAPI}
 */
export class WhitelistApi extends BaseAPI {
    /**
     *
     * @param {WhitelistApiCreateWhitelistRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WhitelistApi
     */
    createWhitelist(requestParameters, options) {
        return WhitelistApiFp(this.configuration).createWhitelist(requestParameters.whitelistCreateData, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {WhitelistApiDeleteWhitelistRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WhitelistApi
     */
    deleteWhitelist(requestParameters, options) {
        return WhitelistApiFp(this.configuration).deleteWhitelist(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {WhitelistApiGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WhitelistApi
     */
    get(requestParameters, options) {
        return WhitelistApiFp(this.configuration).get(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {WhitelistApiGetByWalletAndCollectionRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WhitelistApi
     */
    getByWalletAndCollection(requestParameters, options) {
        return WhitelistApiFp(this.configuration).getByWalletAndCollection(requestParameters.contractAddress, requestParameters.walletAddress, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {WhitelistApiListRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WhitelistApi
     */
    list(requestParameters = {}, options) {
        return WhitelistApiFp(this.configuration).list(requestParameters.limit, requestParameters.offset, requestParameters.sort, requestParameters.collectionId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {WhitelistApiUpdateWhitelistRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WhitelistApi
     */
    updateWhitelist(requestParameters, options) {
        return WhitelistApiFp(this.configuration).updateWhitelist(requestParameters.id, requestParameters.whitelistUpdateData, options).then((request) => request(this.axios, this.basePath));
    }
}
